/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/node-fetch/browser.js":
/*!********************************************!*\
  !*** ./node_modules/node-fetch/browser.js ***!
  \********************************************/
/***/ ((module, exports, __webpack_require__) => {

"use strict";


// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof __webpack_require__.g !== 'undefined') { return __webpack_require__.g; }
	throw new Error('unable to locate global object');
}

var globalObject = getGlobal();

module.exports = exports = globalObject.fetch;

// Needed for TypeScript and Webpack.
if (globalObject.fetch) {
	exports["default"] = globalObject.fetch.bind(globalObject);
}

exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/config/utils.js":
/*!*******************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/config/utils.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultEuCountries = exports.defaultCountriesFlags = exports.defaultCountries = exports.defaultCountriesCurrencies = exports.defaultContinents = void 0;
exports.defaultContinents = {
    "BD": { "code": "AS", "name": "Asia" },
    "BE": { "code": "EU", "name": "Europe" },
    "BF": { "code": "AF", "name": "Africa" },
    "BG": { "code": "EU", "name": "Europe" },
    "BA": { "code": "EU", "name": "Europe" },
    "BB": { "code": "NA", "name": "North America" },
    "WF": { "code": "OC", "name": "Oceania" },
    "BL": { "code": "NA", "name": "North America" },
    "BM": { "code": "NA", "name": "North America" },
    "BN": { "code": "AS", "name": "Asia" },
    "BO": { "code": "SA", "name": "South America" },
    "BH": { "code": "AS", "name": "Asia" },
    "BI": { "code": "AF", "name": "Africa" },
    "BJ": { "code": "AF", "name": "Africa" },
    "BT": { "code": "AS", "name": "Asia" },
    "JM": { "code": "NA", "name": "North America" },
    "BV": { "code": "AN", "name": "Antarctica" },
    "BW": { "code": "AF", "name": "Africa" },
    "WS": { "code": "OC", "name": "Oceania" },
    "BQ": { "code": "NA", "name": "North America" },
    "BR": { "code": "SA", "name": "South America" },
    "BS": { "code": "NA", "name": "North America" },
    "JE": { "code": "EU", "name": "Europe" },
    "BY": { "code": "EU", "name": "Europe" },
    "BZ": { "code": "NA", "name": "North America" },
    "RU": { "code": "EU", "name": "Europe" },
    "RW": { "code": "AF", "name": "Africa" },
    "RS": { "code": "EU", "name": "Europe" },
    "TL": { "code": "OC", "name": "Oceania" },
    "RE": { "code": "AF", "name": "Africa" },
    "TM": { "code": "AS", "name": "Asia" },
    "TJ": { "code": "AS", "name": "Asia" },
    "RO": { "code": "EU", "name": "Europe" },
    "TK": { "code": "OC", "name": "Oceania" },
    "GW": { "code": "AF", "name": "Africa" },
    "GU": { "code": "OC", "name": "Oceania" },
    "GT": { "code": "NA", "name": "North America" },
    "GS": { "code": "AN", "name": "Antarctica" },
    "GR": { "code": "EU", "name": "Europe" },
    "GQ": { "code": "AF", "name": "Africa" },
    "GP": { "code": "NA", "name": "North America" },
    "JP": { "code": "AS", "name": "Asia" },
    "GY": { "code": "SA", "name": "South America" },
    "GG": { "code": "EU", "name": "Europe" },
    "GF": { "code": "SA", "name": "South America" },
    "GE": { "code": "AS", "name": "Asia" },
    "GD": { "code": "NA", "name": "North America" },
    "GB": { "code": "EU", "name": "Europe" },
    "GA": { "code": "AF", "name": "Africa" },
    "SV": { "code": "NA", "name": "North America" },
    "GN": { "code": "AF", "name": "Africa" },
    "GM": { "code": "AF", "name": "Africa" },
    "GL": { "code": "NA", "name": "North America" },
    "GI": { "code": "EU", "name": "Europe" },
    "GH": { "code": "AF", "name": "Africa" },
    "OM": { "code": "AS", "name": "Asia" },
    "TN": { "code": "AF", "name": "Africa" },
    "JO": { "code": "AS", "name": "Asia" },
    "HR": { "code": "EU", "name": "Europe" },
    "HT": { "code": "NA", "name": "North America" },
    "HU": { "code": "EU", "name": "Europe" },
    "HK": { "code": "AS", "name": "Asia" },
    "HN": { "code": "NA", "name": "North America" },
    "HM": { "code": "AN", "name": "Antarctica" },
    "VE": { "code": "SA", "name": "South America" },
    "PR": { "code": "NA", "name": "North America" },
    "PS": { "code": "AS", "name": "Asia" },
    "PW": { "code": "OC", "name": "Oceania" },
    "PT": { "code": "EU", "name": "Europe" },
    "SJ": { "code": "EU", "name": "Europe" },
    "PY": { "code": "SA", "name": "South America" },
    "IQ": { "code": "AS", "name": "Asia" },
    "PA": { "code": "NA", "name": "North America" },
    "PF": { "code": "OC", "name": "Oceania" },
    "PG": { "code": "OC", "name": "Oceania" },
    "PE": { "code": "SA", "name": "South America" },
    "PK": { "code": "AS", "name": "Asia" },
    "PH": { "code": "AS", "name": "Asia" },
    "PN": { "code": "OC", "name": "Oceania" },
    "PL": { "code": "EU", "name": "Europe" },
    "PM": { "code": "NA", "name": "North America" },
    "ZM": { "code": "AF", "name": "Africa" },
    "EH": { "code": "AF", "name": "Africa" },
    "EE": { "code": "EU", "name": "Europe" },
    "EG": { "code": "AF", "name": "Africa" },
    "ZA": { "code": "AF", "name": "Africa" },
    "EC": { "code": "SA", "name": "South America" },
    "IT": { "code": "EU", "name": "Europe" },
    "VN": { "code": "AS", "name": "Asia" },
    "SB": { "code": "OC", "name": "Oceania" },
    "ET": { "code": "AF", "name": "Africa" },
    "SO": { "code": "AF", "name": "Africa" },
    "ZW": { "code": "AF", "name": "Africa" },
    "SA": { "code": "AS", "name": "Asia" },
    "ES": { "code": "EU", "name": "Europe" },
    "ER": { "code": "AF", "name": "Africa" },
    "ME": { "code": "EU", "name": "Europe" },
    "MD": { "code": "EU", "name": "Europe" },
    "MG": { "code": "AF", "name": "Africa" },
    "MF": { "code": "NA", "name": "North America" },
    "MA": { "code": "AF", "name": "Africa" },
    "MC": { "code": "EU", "name": "Europe" },
    "UZ": { "code": "AS", "name": "Asia" },
    "MM": { "code": "AS", "name": "Asia" },
    "ML": { "code": "AF", "name": "Africa" },
    "MO": { "code": "AS", "name": "Asia" },
    "MN": { "code": "AS", "name": "Asia" },
    "MH": { "code": "OC", "name": "Oceania" },
    "MK": { "code": "EU", "name": "Europe" },
    "MU": { "code": "AF", "name": "Africa" },
    "MT": { "code": "EU", "name": "Europe" },
    "MW": { "code": "AF", "name": "Africa" },
    "MV": { "code": "AS", "name": "Asia" },
    "MQ": { "code": "NA", "name": "North America" },
    "MP": { "code": "OC", "name": "Oceania" },
    "MS": { "code": "NA", "name": "North America" },
    "MR": { "code": "AF", "name": "Africa" },
    "IM": { "code": "EU", "name": "Europe" },
    "UG": { "code": "AF", "name": "Africa" },
    "TZ": { "code": "AF", "name": "Africa" },
    "MY": { "code": "AS", "name": "Asia" },
    "MX": { "code": "NA", "name": "North America" },
    "IL": { "code": "AS", "name": "Asia" },
    "FR": { "code": "EU", "name": "Europe" },
    "IO": { "code": "AS", "name": "Asia" },
    "SH": { "code": "AF", "name": "Africa" },
    "FI": { "code": "EU", "name": "Europe" },
    "FJ": { "code": "OC", "name": "Oceania" },
    "FK": { "code": "SA", "name": "South America" },
    "FM": { "code": "OC", "name": "Oceania" },
    "FO": { "code": "EU", "name": "Europe" },
    "NI": { "code": "NA", "name": "North America" },
    "NL": { "code": "EU", "name": "Europe" },
    "NO": { "code": "EU", "name": "Europe" },
    "NA": { "code": "AF", "name": "Africa" },
    "VU": { "code": "OC", "name": "Oceania" },
    "NC": { "code": "OC", "name": "Oceania" },
    "NE": { "code": "AF", "name": "Africa" },
    "NF": { "code": "OC", "name": "Oceania" },
    "NG": { "code": "AF", "name": "Africa" },
    "NZ": { "code": "OC", "name": "Oceania" },
    "NP": { "code": "AS", "name": "Asia" },
    "NR": { "code": "OC", "name": "Oceania" },
    "NU": { "code": "OC", "name": "Oceania" },
    "CK": { "code": "OC", "name": "Oceania" },
    "XK": { "code": "EU", "name": "Europe" },
    "CI": { "code": "AF", "name": "Africa" },
    "CH": { "code": "EU", "name": "Europe" },
    "CO": { "code": "SA", "name": "South America" },
    "CN": { "code": "AS", "name": "Asia" },
    "CM": { "code": "AF", "name": "Africa" },
    "CL": { "code": "SA", "name": "South America" },
    "CC": { "code": "AS", "name": "Asia" },
    "CA": { "code": "NA", "name": "North America" },
    "CG": { "code": "AF", "name": "Africa" },
    "CF": { "code": "AF", "name": "Africa" },
    "CD": { "code": "AF", "name": "Africa" },
    "CZ": { "code": "EU", "name": "Europe" },
    "CY": { "code": "EU", "name": "Europe" },
    "CX": { "code": "AS", "name": "Asia" },
    "CR": { "code": "NA", "name": "North America" },
    "CW": { "code": "NA", "name": "North America" },
    "CV": { "code": "AF", "name": "Africa" },
    "CU": { "code": "NA", "name": "North America" },
    "SZ": { "code": "AF", "name": "Africa" },
    "SY": { "code": "AS", "name": "Asia" },
    "SX": { "code": "NA", "name": "North America" },
    "KG": { "code": "AS", "name": "Asia" },
    "KE": { "code": "AF", "name": "Africa" },
    "SS": { "code": "AF", "name": "Africa" },
    "SR": { "code": "SA", "name": "South America" },
    "KI": { "code": "OC", "name": "Oceania" },
    "KH": { "code": "AS", "name": "Asia" },
    "KN": { "code": "NA", "name": "North America" },
    "KM": { "code": "AF", "name": "Africa" },
    "ST": { "code": "AF", "name": "Africa" },
    "SK": { "code": "EU", "name": "Europe" },
    "KR": { "code": "AS", "name": "Asia" },
    "SI": { "code": "EU", "name": "Europe" },
    "KP": { "code": "AS", "name": "Asia" },
    "KW": { "code": "AS", "name": "Asia" },
    "SN": { "code": "AF", "name": "Africa" },
    "SM": { "code": "EU", "name": "Europe" },
    "SL": { "code": "AF", "name": "Africa" },
    "SC": { "code": "AF", "name": "Africa" },
    "KZ": { "code": "AS", "name": "Asia" },
    "KY": { "code": "NA", "name": "North America" },
    "SG": { "code": "AS", "name": "Asia" },
    "SE": { "code": "EU", "name": "Europe" },
    "SD": { "code": "AF", "name": "Africa" },
    "DO": { "code": "NA", "name": "North America" },
    "DM": { "code": "NA", "name": "North America" },
    "DJ": { "code": "AF", "name": "Africa" },
    "DK": { "code": "EU", "name": "Europe" },
    "VG": { "code": "NA", "name": "North America" },
    "DE": { "code": "EU", "name": "Europe" },
    "YE": { "code": "AS", "name": "Asia" },
    "DZ": { "code": "AF", "name": "Africa" },
    "US": { "code": "NA", "name": "North America" },
    "UY": { "code": "SA", "name": "South America" },
    "YT": { "code": "AF", "name": "Africa" },
    "UM": { "code": "OC", "name": "Oceania" },
    "LB": { "code": "AS", "name": "Asia" },
    "LC": { "code": "NA", "name": "North America" },
    "LA": { "code": "AS", "name": "Asia" },
    "TV": { "code": "OC", "name": "Oceania" },
    "TW": { "code": "AS", "name": "Asia" },
    "TT": { "code": "NA", "name": "North America" },
    "TR": { "code": "AS", "name": "Asia" },
    "LK": { "code": "AS", "name": "Asia" },
    "LI": { "code": "EU", "name": "Europe" },
    "LV": { "code": "EU", "name": "Europe" },
    "TO": { "code": "OC", "name": "Oceania" },
    "LT": { "code": "EU", "name": "Europe" },
    "LU": { "code": "EU", "name": "Europe" },
    "LR": { "code": "AF", "name": "Africa" },
    "LS": { "code": "AF", "name": "Africa" },
    "TH": { "code": "AS", "name": "Asia" },
    "TF": { "code": "AN", "name": "Antarctica" },
    "TG": { "code": "AF", "name": "Africa" },
    "TD": { "code": "AF", "name": "Africa" },
    "TC": { "code": "NA", "name": "North America" },
    "LY": { "code": "AF", "name": "Africa" },
    "VA": { "code": "EU", "name": "Europe" },
    "VC": { "code": "NA", "name": "North America" },
    "AE": { "code": "AS", "name": "Asia" },
    "AD": { "code": "EU", "name": "Europe" },
    "AG": { "code": "NA", "name": "North America" },
    "AF": { "code": "AS", "name": "Asia" },
    "AI": { "code": "NA", "name": "North America" },
    "VI": { "code": "NA", "name": "North America" },
    "IS": { "code": "EU", "name": "Europe" },
    "IR": { "code": "AS", "name": "Asia" },
    "AM": { "code": "AS", "name": "Asia" },
    "AL": { "code": "EU", "name": "Europe" },
    "AO": { "code": "AF", "name": "Africa" },
    "AQ": { "code": "AN", "name": "Antarctica" },
    "AS": { "code": "OC", "name": "Oceania" },
    "AR": { "code": "SA", "name": "South America" },
    "AU": { "code": "OC", "name": "Oceania" },
    "AT": { "code": "EU", "name": "Europe" },
    "AW": { "code": "NA", "name": "North America" },
    "IN": { "code": "AS", "name": "Asia" },
    "AX": { "code": "EU", "name": "Europe" },
    "AZ": { "code": "AS", "name": "Asia" },
    "IE": { "code": "EU", "name": "Europe" },
    "ID": { "code": "AS", "name": "Asia" },
    "UA": { "code": "EU", "name": "Europe" },
    "QA": { "code": "AS", "name": "Asia" },
    "MZ": { "code": "AF", "name": "Africa" }
};
exports.defaultCountriesCurrencies = {
    "AD": { "code": "EUR", "symbol": "€" },
    "AE": { "code": "AED", "symbol": "د.إ" },
    "AF": { "code": "AFN", "symbol": "؋" },
    "AG": { "code": "XCD", "symbol": "$" },
    "AI": { "code": "XCD", "symbol": "$" },
    "AL": { "code": "ALL", "symbol": "L" },
    "AM": { "code": "AMD", "symbol": "֏" },
    "AO": { "code": "AOA", "symbol": "Kz" },
    "AQ": { "code": "", "symbol": "$" },
    "AR": { "code": "ARS", "symbol": "$" },
    "AS": { "code": "USD", "symbol": "$" },
    "AT": { "code": "EUR", "symbol": "€" },
    "AU": { "code": "AUD", "symbol": "$" },
    "AW": { "code": "AWG", "symbol": "ƒ" },
    "AX": { "code": "EUR", "symbol": "€" },
    "AZ": { "code": "AZN", "symbol": "₼" },
    "BA": { "code": "BAM", "symbol": "KM" },
    "BB": { "code": "BBD", "symbol": "$" },
    "BD": { "code": "BDT", "symbol": "৳" },
    "BE": { "code": "EUR", "symbol": "€" },
    "BF": { "code": "XOF", "symbol": "CFA" },
    "BG": { "code": "BGN", "symbol": "лв" },
    "BH": { "code": "BHD", "symbol": ".د.ب" },
    "BI": { "code": "BIF", "symbol": "FBu" },
    "BJ": { "code": "XOF", "symbol": "CFA" },
    "BL": { "code": "EUR", "symbol": "€" },
    "BM": { "code": "BMD", "symbol": "$" },
    "BN": { "code": "BND", "symbol": "$" },
    "BO": { "code": "BOB", "symbol": "$b" },
    "BQ": { "code": "USD", "symbol": "$" },
    "BR": { "code": "BRL", "symbol": "R$" },
    "BS": { "code": "BSD", "symbol": "$" },
    "BT": { "code": "BTN", "symbol": "Nu." },
    "BV": { "code": "NOK", "symbol": "kr" },
    "BW": { "code": "BWP", "symbol": "P" },
    "BY": { "code": "BYR", "symbol": "Br" },
    "BZ": { "code": "BZD", "symbol": "BZ$" },
    "CA": { "code": "CAD", "symbol": "$" },
    "CC": { "code": "AUD", "symbol": "$" },
    "CD": { "code": "CDF", "symbol": "FC" },
    "CF": { "code": "XAF", "symbol": "FCFA" },
    "CG": { "code": "XAF", "symbol": "FCFA" },
    "CH": { "code": "CHF", "symbol": "CHF" },
    "CI": { "code": "XOF", "symbol": "CFA" },
    "CK": { "code": "NZD", "symbol": "$" },
    "CL": { "code": "CLP", "symbol": "$" },
    "CM": { "code": "XAF", "symbol": "FCFA" },
    "CN": { "code": "CNY", "symbol": "¥" },
    "CO": { "code": "COP", "symbol": "$" },
    "CR": { "code": "CRC", "symbol": "₡" },
    "CU": { "code": "CUP", "symbol": "₱" },
    "CV": { "code": "CVE", "symbol": "$" },
    "CW": { "code": "ANG", "symbol": "ƒ" },
    "CX": { "code": "AUD", "symbol": "$" },
    "CY": { "code": "EUR", "symbol": "€" },
    "CZ": { "code": "CZK", "symbol": "Kč" },
    "DE": { "code": "EUR", "symbol": "€" },
    "DJ": { "code": "DJF", "symbol": "Fdj" },
    "DK": { "code": "DKK", "symbol": "kr" },
    "DM": { "code": "XCD", "symbol": "$" },
    "DO": { "code": "DOP", "symbol": "RD$" },
    "DZ": { "code": "DZD", "symbol": "دج" },
    "EC": { "code": "USD", "symbol": "$" },
    "EE": { "code": "EUR", "symbol": "€" },
    "EG": { "code": "EGP", "symbol": "£" },
    "EH": { "code": "MAD", "symbol": "MAD" },
    "ER": { "code": "ERN", "symbol": "Nfk" },
    "ES": { "code": "EUR", "symbol": "€" },
    "ET": { "code": "ETB", "symbol": "Br" },
    "FI": { "code": "EUR", "symbol": "€" },
    "FJ": { "code": "FJD", "symbol": "$" },
    "FK": { "code": "FKP", "symbol": "£" },
    "FM": { "code": "USD", "symbol": "$" },
    "FO": { "code": "DKK", "symbol": "kr" },
    "FR": { "code": "EUR", "symbol": "€" },
    "GA": { "code": "XAF", "symbol": "FCFA" },
    "GB": { "code": "GBP", "symbol": "£" },
    "GD": { "code": "XCD", "symbol": "$" },
    "GE": { "code": "GEL", "symbol": "ლ" },
    "GF": { "code": "EUR", "symbol": "€" },
    "GG": { "code": "GBP", "symbol": "£" },
    "GH": { "code": "GHS", "symbol": "GH₵" },
    "GI": { "code": "GIP", "symbol": "£" },
    "GL": { "code": "DKK", "symbol": "kr" },
    "GM": { "code": "GMD", "symbol": "D" },
    "GN": { "code": "GNF", "symbol": "FG" },
    "GP": { "code": "EUR", "symbol": "€" },
    "GQ": { "code": "XAF", "symbol": "FCFA" },
    "GR": { "code": "EUR", "symbol": "€" },
    "GS": { "code": "GBP", "symbol": "£" },
    "GT": { "code": "GTQ", "symbol": "Q" },
    "GU": { "code": "USD", "symbol": "$" },
    "GW": { "code": "XOF", "symbol": "CFA" },
    "GY": { "code": "GYD", "symbol": "$" },
    "HK": { "code": "HKD", "symbol": "$" },
    "HM": { "code": "AUD", "symbol": "$" },
    "HN": { "code": "HNL", "symbol": "L" },
    "HR": { "code": "HRK", "symbol": "kn" },
    "HT": { "code": "HTG", "symbol": "G" },
    "HU": { "code": "HUF", "symbol": "Ft" },
    "ID": { "code": "IDR", "symbol": "Rp" },
    "IE": { "code": "EUR", "symbol": "€" },
    "IL": { "code": "ILS", "symbol": "₪" },
    "IM": { "code": "GBP", "symbol": "£" },
    "IN": { "code": "INR", "symbol": "₹" },
    "IO": { "code": "USD", "symbol": "$" },
    "IQ": { "code": "IQD", "symbol": "ع.د" },
    "IR": { "code": "IRR", "symbol": "﷼" },
    "IS": { "code": "ISK", "symbol": "kr" },
    "IT": { "code": "EUR", "symbol": "€" },
    "JE": { "code": "GBP", "symbol": "£" },
    "JM": { "code": "JMD", "symbol": "J$" },
    "JO": { "code": "JOD", "symbol": "JD" },
    "JP": { "code": "JPY", "symbol": "¥" },
    "KE": { "code": "KES", "symbol": "KSh" },
    "KG": { "code": "KGS", "symbol": "лв" },
    "KH": { "code": "KHR", "symbol": "៛" },
    "KI": { "code": "AUD", "symbol": "$" },
    "KM": { "code": "KMF", "symbol": "CF" },
    "KN": { "code": "XCD", "symbol": "$" },
    "KP": { "code": "KPW", "symbol": "₩" },
    "KR": { "code": "KRW", "symbol": "₩" },
    "KW": { "code": "KWD", "symbol": "KD" },
    "KY": { "code": "KYD", "symbol": "$" },
    "KZ": { "code": "KZT", "symbol": "₸" },
    "LA": { "code": "LAK", "symbol": "₭" },
    "LB": { "code": "LBP", "symbol": "£" },
    "LC": { "code": "XCD", "symbol": "$" },
    "LI": { "code": "CHF", "symbol": "CHF" },
    "LK": { "code": "LKR", "symbol": "₨" },
    "LR": { "code": "LRD", "symbol": "$" },
    "LS": { "code": "LSL", "symbol": "M" },
    "LT": { "code": "LTL", "symbol": "Lt" },
    "LU": { "code": "EUR", "symbol": "€" },
    "LV": { "code": "EUR", "symbol": "€" },
    "LY": { "code": "LYD", "symbol": "LD" },
    "MA": { "code": "MAD", "symbol": "MAD" },
    "MC": { "code": "EUR", "symbol": "€" },
    "MD": { "code": "MDL", "symbol": "lei" },
    "ME": { "code": "EUR", "symbol": "€" },
    "MF": { "code": "EUR", "symbol": "€" },
    "MG": { "code": "MGA", "symbol": "Ar" },
    "MH": { "code": "USD", "symbol": "$" },
    "MK": { "code": "MKD", "symbol": "ден" },
    "ML": { "code": "XOF", "symbol": "CFA" },
    "MM": { "code": "MMK", "symbol": "K" },
    "MN": { "code": "MNT", "symbol": "₮" },
    "MO": { "code": "MOP", "symbol": "MOP$" },
    "MP": { "code": "USD", "symbol": "$" },
    "MQ": { "code": "EUR", "symbol": "€" },
    "MR": { "code": "MRO", "symbol": "UM" },
    "MS": { "code": "XCD", "symbol": "$" },
    "MT": { "code": "EUR", "symbol": "€" },
    "MU": { "code": "MUR", "symbol": "₨" },
    "MV": { "code": "MVR", "symbol": "Rf" },
    "MW": { "code": "MWK", "symbol": "MK" },
    "MX": { "code": "MXN", "symbol": "$" },
    "MY": { "code": "MYR", "symbol": "RM" },
    "MZ": { "code": "MZN", "symbol": "MT" },
    "NA": { "code": "NAD", "symbol": "$" },
    "NC": { "code": "XPF", "symbol": "₣" },
    "NE": { "code": "XOF", "symbol": "CFA" },
    "NF": { "code": "AUD", "symbol": "$" },
    "NG": { "code": "NGN", "symbol": "₦" },
    "NI": { "code": "NIO", "symbol": "C$" },
    "NL": { "code": "EUR", "symbol": "€" },
    "NO": { "code": "NOK", "symbol": "kr" },
    "NP": { "code": "NPR", "symbol": "₨" },
    "NR": { "code": "AUD", "symbol": "$" },
    "NU": { "code": "NZD", "symbol": "$" },
    "NZ": { "code": "NZD", "symbol": "$" },
    "OM": { "code": "OMR", "symbol": "﷼" },
    "PA": { "code": "PAB", "symbol": "B/." },
    "PE": { "code": "PEN", "symbol": "S/." },
    "PF": { "code": "XPF", "symbol": "₣" },
    "PG": { "code": "PGK", "symbol": "K" },
    "PH": { "code": "PHP", "symbol": "₱" },
    "PK": { "code": "PKR", "symbol": "₨" },
    "PL": { "code": "PLN", "symbol": "zł" },
    "PM": { "code": "EUR", "symbol": "€" },
    "PN": { "code": "NZD", "symbol": "$" },
    "PR": { "code": "USD", "symbol": "$" },
    "PS": { "code": "ILS", "symbol": "₪" },
    "PT": { "code": "EUR", "symbol": "€" },
    "PW": { "code": "USD", "symbol": "$" },
    "PY": { "code": "PYG", "symbol": "Gs" },
    "QA": { "code": "QAR", "symbol": "﷼" },
    "RE": { "code": "EUR", "symbol": "€" },
    "RO": { "code": "RON", "symbol": "lei" },
    "RS": { "code": "RSD", "symbol": "Дин." },
    "RU": { "code": "RUB", "symbol": "₽" },
    "RW": { "code": "RWF", "symbol": "R₣" },
    "SA": { "code": "SAR", "symbol": "﷼" },
    "SB": { "code": "SBD", "symbol": "$" },
    "SC": { "code": "SCR", "symbol": "₨" },
    "SD": { "code": "SDG", "symbol": "ج.س." },
    "SE": { "code": "SEK", "symbol": "kr" },
    "SG": { "code": "SGD", "symbol": "S$" },
    "SH": { "code": "SHP", "symbol": "£" },
    "SI": { "code": "EUR", "symbol": "€" },
    "SJ": { "code": "NOK", "symbol": "kr" },
    "SK": { "code": "EUR", "symbol": "€" },
    "SL": { "code": "SLL", "symbol": "Le" },
    "SM": { "code": "EUR", "symbol": "€" },
    "SN": { "code": "XOF", "symbol": "CFA" },
    "SO": { "code": "SOS", "symbol": "S" },
    "SR": { "code": "SRD", "symbol": "$" },
    "SS": { "code": "SSP", "symbol": "£" },
    "ST": { "code": "STD", "symbol": "Db" },
    "SV": { "code": "USD", "symbol": "$" },
    "SX": { "code": "ANG", "symbol": "ƒ" },
    "SY": { "code": "SYP", "symbol": "£" },
    "SZ": { "code": "SZL", "symbol": "E" },
    "TC": { "code": "USD", "symbol": "$" },
    "TD": { "code": "XAF", "symbol": "FCFA" },
    "TF": { "code": "EUR", "symbol": "€" },
    "TG": { "code": "XOF", "symbol": "CFA" },
    "TH": { "code": "THB", "symbol": "฿" },
    "TJ": { "code": "TJS", "symbol": "SM" },
    "TK": { "code": "NZD", "symbol": "$" },
    "TL": { "code": "USD", "symbol": "$" },
    "TM": { "code": "TMT", "symbol": "T" },
    "TN": { "code": "TND", "symbol": "د.ت" },
    "TO": { "code": "TOP", "symbol": "T$" },
    "TR": { "code": "TRY", "symbol": "₺" },
    "TT": { "code": "TTD", "symbol": "TT$" },
    "TV": { "code": "AUD", "symbol": "$" },
    "TW": { "code": "TWD", "symbol": "NT$" },
    "TZ": { "code": "TZS", "symbol": "TSh" },
    "UA": { "code": "UAH", "symbol": "₴" },
    "UG": { "code": "UGX", "symbol": "USh" },
    "UM": { "code": "USD", "symbol": "$" },
    "US": { "code": "USD", "symbol": "$" },
    "UY": { "code": "UYU", "symbol": "$U" },
    "UZ": { "code": "UZS", "symbol": "лв" },
    "VA": { "code": "EUR", "symbol": "€" },
    "VC": { "code": "XCD", "symbol": "$" },
    "VE": { "code": "VEF", "symbol": "Bs" },
    "VG": { "code": "USD", "symbol": "$" },
    "VI": { "code": "USD", "symbol": "$" },
    "VN": { "code": "VND", "symbol": "₫" },
    "VU": { "code": "VUV", "symbol": "VT" },
    "WF": { "code": "XPF", "symbol": "₣" },
    "WS": { "code": "WST", "symbol": "WS$" },
    "XK": { "code": "EUR", "symbol": "€" },
    "YE": { "code": "YER", "symbol": "﷼" },
    "YT": { "code": "EUR", "symbol": "€" },
    "ZA": { "code": "ZAR", "symbol": "R" },
    "ZM": { "code": "ZMK", "symbol": "ZK" },
    "ZW": { "code": "ZWL", "symbol": "$" }
};
exports.defaultCountries = {
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "WF": "Wallis and Futuna",
    "BL": "Saint Barthelemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BT": "Bhutan",
    "JM": "Jamaica",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "WS": "Samoa",
    "BQ": "Bonaire, Saint Eustatius and Saba ",
    "BR": "Brazil",
    "BS": "Bahamas",
    "JE": "Jersey",
    "BY": "Belarus",
    "BZ": "Belize",
    "RU": "Russia",
    "RW": "Rwanda",
    "RS": "Serbia",
    "TL": "East Timor",
    "RE": "Reunion",
    "TM": "Turkmenistan",
    "TJ": "Tajikistan",
    "RO": "Romania",
    "TK": "Tokelau",
    "GW": "Guinea-Bissau",
    "GU": "Guam",
    "GT": "Guatemala",
    "GS": "South Georgia and the South Sandwich Islands",
    "GR": "Greece",
    "GQ": "Equatorial Guinea",
    "GP": "Guadeloupe",
    "JP": "Japan",
    "GY": "Guyana",
    "GG": "Guernsey",
    "GF": "French Guiana",
    "GE": "Georgia",
    "GD": "Grenada",
    "GB": "United Kingdom",
    "GA": "Gabon",
    "SV": "El Salvador",
    "GN": "Guinea",
    "GM": "Gambia",
    "GL": "Greenland",
    "GI": "Gibraltar",
    "GH": "Ghana",
    "OM": "Oman",
    "TN": "Tunisia",
    "JO": "Jordan",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "HK": "Hong Kong",
    "HN": "Honduras",
    "HM": "Heard Island and McDonald Islands",
    "VE": "Venezuela",
    "PR": "Puerto Rico",
    "PS": "Palestinian Territory",
    "PW": "Palau",
    "PT": "Portugal",
    "SJ": "Svalbard and Jan Mayen",
    "PY": "Paraguay",
    "IQ": "Iraq",
    "PA": "Panama",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PE": "Peru",
    "PK": "Pakistan",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "ZM": "Zambia",
    "EH": "Western Sahara",
    "EE": "Estonia",
    "EG": "Egypt",
    "ZA": "South Africa",
    "EC": "Ecuador",
    "IT": "Italy",
    "VN": "Vietnam",
    "SB": "Solomon Islands",
    "ET": "Ethiopia",
    "SO": "Somalia",
    "ZW": "Zimbabwe",
    "SA": "Saudi Arabia",
    "ES": "Spain",
    "ER": "Eritrea",
    "ME": "Montenegro",
    "MD": "Moldova",
    "MG": "Madagascar",
    "MF": "Saint Martin",
    "MA": "Morocco",
    "MC": "Monaco",
    "UZ": "Uzbekistan",
    "MM": "Myanmar",
    "ML": "Mali",
    "MO": "Macao",
    "MN": "Mongolia",
    "MH": "Marshall Islands",
    "MK": "Macedonia",
    "MU": "Mauritius",
    "MT": "Malta",
    "MW": "Malawi",
    "MV": "Maldives",
    "MQ": "Martinique",
    "MP": "Northern Mariana Islands",
    "MS": "Montserrat",
    "MR": "Mauritania",
    "IM": "Isle of Man",
    "UG": "Uganda",
    "TZ": "Tanzania",
    "MY": "Malaysia",
    "MX": "Mexico",
    "IL": "Israel",
    "FR": "France",
    "IO": "British Indian Ocean Territory",
    "SH": "Saint Helena",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NA": "Namibia",
    "VU": "Vanuatu",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NZ": "New Zealand",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "CK": "Cook Islands",
    "XK": "Kosovo",
    "CI": "Ivory Coast",
    "CH": "Switzerland",
    "CO": "Colombia",
    "CN": "China",
    "CM": "Cameroon",
    "CL": "Chile",
    "CC": "Cocos Islands",
    "CA": "Canada",
    "CG": "Republic of the Congo",
    "CF": "Central African Republic",
    "CD": "Democratic Republic of the Congo",
    "CZ": "Czech Republic",
    "CY": "Cyprus",
    "CX": "Christmas Island",
    "CR": "Costa Rica",
    "CW": "Curacao",
    "CV": "Cape Verde",
    "CU": "Cuba",
    "SZ": "Swaziland",
    "SY": "Syria",
    "SX": "Sint Maarten",
    "KG": "Kyrgyzstan",
    "KE": "Kenya",
    "SS": "South Sudan",
    "SR": "Suriname",
    "KI": "Kiribati",
    "KH": "Cambodia",
    "KN": "Saint Kitts and Nevis",
    "KM": "Comoros",
    "ST": "Sao Tome and Principe",
    "SK": "Slovakia",
    "KR": "South Korea",
    "SI": "Slovenia",
    "KP": "North Korea",
    "KW": "Kuwait",
    "SN": "Senegal",
    "SM": "San Marino",
    "SL": "Sierra Leone",
    "SC": "Seychelles",
    "KZ": "Kazakhstan",
    "KY": "Cayman Islands",
    "SG": "Singapore",
    "SE": "Sweden",
    "SD": "Sudan",
    "DO": "Dominican Republic",
    "DM": "Dominica",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "VG": "British Virgin Islands",
    "DE": "Germany",
    "YE": "Yemen",
    "DZ": "Algeria",
    "US": "United States",
    "UY": "Uruguay",
    "YT": "Mayotte",
    "UM": "United States Minor Outlying Islands",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LA": "Laos",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TT": "Trinidad and Tobago",
    "TR": "Turkey",
    "LK": "Sri Lanka",
    "LI": "Liechtenstein",
    "LV": "Latvia",
    "TO": "Tonga",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LR": "Liberia",
    "LS": "Lesotho",
    "TH": "Thailand",
    "TF": "French Southern Territories",
    "TG": "Togo",
    "TD": "Chad",
    "TC": "Turks and Caicos Islands",
    "LY": "Libya",
    "VA": "Vatican",
    "VC": "Saint Vincent and the Grenadines",
    "AE": "United Arab Emirates",
    "AD": "Andorra",
    "AG": "Antigua and Barbuda",
    "AF": "Afghanistan",
    "AI": "Anguilla",
    "VI": "U.S. Virgin Islands",
    "IS": "Iceland",
    "IR": "Iran",
    "AM": "Armenia",
    "AL": "Albania",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AS": "American Samoa",
    "AR": "Argentina",
    "AU": "Australia",
    "AT": "Austria",
    "AW": "Aruba",
    "IN": "India",
    "AX": "Aland Islands",
    "AZ": "Azerbaijan",
    "IE": "Ireland",
    "ID": "Indonesia",
    "UA": "Ukraine",
    "QA": "Qatar",
    "MZ": "Mozambique"
};
exports.defaultCountriesFlags = {
    "AD": { "emoji": "🇦🇩", "unicode": "U+1F1E6 U+1F1E9" },
    "AE": { "emoji": "🇦🇪", "unicode": "U+1F1E6 U+1F1EA" },
    "AF": { "emoji": "🇦🇫", "unicode": "U+1F1E6 U+1F1EB" },
    "AG": { "emoji": "🇦🇬", "unicode": "U+1F1E6 U+1F1EC" },
    "AI": { "emoji": "🇦🇮", "unicode": "U+1F1E6 U+1F1EE" },
    "AL": { "emoji": "🇦🇱", "unicode": "U+1F1E6 U+1F1F1" },
    "AM": { "emoji": "🇦🇲", "unicode": "U+1F1E6 U+1F1F2" },
    "AO": { "emoji": "🇦🇴", "unicode": "U+1F1E6 U+1F1F4" },
    "AQ": { "emoji": "🇦🇶", "unicode": "U+1F1E6 U+1F1F6" },
    "AR": { "emoji": "🇦🇷", "unicode": "U+1F1E6 U+1F1F7" },
    "AS": { "emoji": "🇦🇸", "unicode": "U+1F1E6 U+1F1F8" },
    "AT": { "emoji": "🇦🇹", "unicode": "U+1F1E6 U+1F1F9" },
    "AU": { "emoji": "🇦🇺", "unicode": "U+1F1E6 U+1F1FA" },
    "AW": { "emoji": "🇦🇼", "unicode": "U+1F1E6 U+1F1FC" },
    "AX": { "emoji": "🇦🇽", "unicode": "U+1F1E6 U+1F1FD" },
    "AZ": { "emoji": "🇦🇿", "unicode": "U+1F1E6 U+1F1FF" },
    "BA": { "emoji": "🇧🇦", "unicode": "U+1F1E7 U+1F1E6" },
    "BB": { "emoji": "🇧🇧", "unicode": "U+1F1E7 U+1F1E7" },
    "BD": { "emoji": "🇧🇩", "unicode": "U+1F1E7 U+1F1E9" },
    "BE": { "emoji": "🇧🇪", "unicode": "U+1F1E7 U+1F1EA" },
    "BF": { "emoji": "🇧🇫", "unicode": "U+1F1E7 U+1F1EB" },
    "BG": { "emoji": "🇧🇬", "unicode": "U+1F1E7 U+1F1EC" },
    "BH": { "emoji": "🇧🇭", "unicode": "U+1F1E7 U+1F1ED" },
    "BI": { "emoji": "🇧🇮", "unicode": "U+1F1E7 U+1F1EE" },
    "BJ": { "emoji": "🇧🇯", "unicode": "U+1F1E7 U+1F1EF" },
    "BL": { "emoji": "🇧🇱", "unicode": "U+1F1E7 U+1F1F1" },
    "BM": { "emoji": "🇧🇲", "unicode": "U+1F1E7 U+1F1F2" },
    "BN": { "emoji": "🇧🇳", "unicode": "U+1F1E7 U+1F1F3" },
    "BO": { "emoji": "🇧🇴", "unicode": "U+1F1E7 U+1F1F4" },
    "BQ": { "emoji": "🇧🇶", "unicode": "U+1F1E7 U+1F1F6" },
    "BR": { "emoji": "🇧🇷", "unicode": "U+1F1E7 U+1F1F7" },
    "BS": { "emoji": "🇧🇸", "unicode": "U+1F1E7 U+1F1F8" },
    "BT": { "emoji": "🇧🇹", "unicode": "U+1F1E7 U+1F1F9" },
    "BV": { "emoji": "🇧🇻", "unicode": "U+1F1E7 U+1F1FB" },
    "BW": { "emoji": "🇧🇼", "unicode": "U+1F1E7 U+1F1FC" },
    "BY": { "emoji": "🇧🇾", "unicode": "U+1F1E7 U+1F1FE" },
    "BZ": { "emoji": "🇧🇿", "unicode": "U+1F1E7 U+1F1FF" },
    "CA": { "emoji": "🇨🇦", "unicode": "U+1F1E8 U+1F1E6" },
    "CC": { "emoji": "🇨🇨", "unicode": "U+1F1E8 U+1F1E8" },
    "CD": { "emoji": "🇨🇩", "unicode": "U+1F1E8 U+1F1E9" },
    "CF": { "emoji": "🇨🇫", "unicode": "U+1F1E8 U+1F1EB" },
    "CG": { "emoji": "🇨🇬", "unicode": "U+1F1E8 U+1F1EC" },
    "CH": { "emoji": "🇨🇭", "unicode": "U+1F1E8 U+1F1ED" },
    "CI": { "emoji": "🇨🇮", "unicode": "U+1F1E8 U+1F1EE" },
    "CK": { "emoji": "🇨🇰", "unicode": "U+1F1E8 U+1F1F0" },
    "CL": { "emoji": "🇨🇱", "unicode": "U+1F1E8 U+1F1F1" },
    "CM": { "emoji": "🇨🇲", "unicode": "U+1F1E8 U+1F1F2" },
    "CN": { "emoji": "🇨🇳", "unicode": "U+1F1E8 U+1F1F3" },
    "CO": { "emoji": "🇨🇴", "unicode": "U+1F1E8 U+1F1F4" },
    "CR": { "emoji": "🇨🇷", "unicode": "U+1F1E8 U+1F1F7" },
    "CU": { "emoji": "🇨🇺", "unicode": "U+1F1E8 U+1F1FA" },
    "CV": { "emoji": "🇨🇻", "unicode": "U+1F1E8 U+1F1FB" },
    "CW": { "emoji": "🇨🇼", "unicode": "U+1F1E8 U+1F1FC" },
    "CX": { "emoji": "🇨🇽", "unicode": "U+1F1E8 U+1F1FD" },
    "CY": { "emoji": "🇨🇾", "unicode": "U+1F1E8 U+1F1FE" },
    "CZ": { "emoji": "🇨🇿", "unicode": "U+1F1E8 U+1F1FF" },
    "DE": { "emoji": "🇩🇪", "unicode": "U+1F1E9 U+1F1EA" },
    "DJ": { "emoji": "🇩🇯", "unicode": "U+1F1E9 U+1F1EF" },
    "DK": { "emoji": "🇩🇰", "unicode": "U+1F1E9 U+1F1F0" },
    "DM": { "emoji": "🇩🇲", "unicode": "U+1F1E9 U+1F1F2" },
    "DO": { "emoji": "🇩🇴", "unicode": "U+1F1E9 U+1F1F4" },
    "DZ": { "emoji": "🇩🇿", "unicode": "U+1F1E9 U+1F1FF" },
    "EC": { "emoji": "🇪🇨", "unicode": "U+1F1EA U+1F1E8" },
    "EE": { "emoji": "🇪🇪", "unicode": "U+1F1EA U+1F1EA" },
    "EG": { "emoji": "🇪🇬", "unicode": "U+1F1EA U+1F1EC" },
    "EH": { "emoji": "🇪🇭", "unicode": "U+1F1EA U+1F1ED" },
    "ER": { "emoji": "🇪🇷", "unicode": "U+1F1EA U+1F1F7" },
    "ES": { "emoji": "🇪🇸", "unicode": "U+1F1EA U+1F1F8" },
    "ET": { "emoji": "🇪🇹", "unicode": "U+1F1EA U+1F1F9" },
    "FI": { "emoji": "🇫🇮", "unicode": "U+1F1EB U+1F1EE" },
    "FJ": { "emoji": "🇫🇯", "unicode": "U+1F1EB U+1F1EF" },
    "FK": { "emoji": "🇫🇰", "unicode": "U+1F1EB U+1F1F0" },
    "FM": { "emoji": "🇫🇲", "unicode": "U+1F1EB U+1F1F2" },
    "FO": { "emoji": "🇫🇴", "unicode": "U+1F1EB U+1F1F4" },
    "FR": { "emoji": "🇫🇷", "unicode": "U+1F1EB U+1F1F7" },
    "GA": { "emoji": "🇬🇦", "unicode": "U+1F1EC U+1F1E6" },
    "GB": { "emoji": "🇬🇧", "unicode": "U+1F1EC U+1F1E7" },
    "GD": { "emoji": "🇬🇩", "unicode": "U+1F1EC U+1F1E9" },
    "GE": { "emoji": "🇬🇪", "unicode": "U+1F1EC U+1F1EA" },
    "GF": { "emoji": "🇬🇫", "unicode": "U+1F1EC U+1F1EB" },
    "GG": { "emoji": "🇬🇬", "unicode": "U+1F1EC U+1F1EC" },
    "GH": { "emoji": "🇬🇭", "unicode": "U+1F1EC U+1F1ED" },
    "GI": { "emoji": "🇬🇮", "unicode": "U+1F1EC U+1F1EE" },
    "GL": { "emoji": "🇬🇱", "unicode": "U+1F1EC U+1F1F1" },
    "GM": { "emoji": "🇬🇲", "unicode": "U+1F1EC U+1F1F2" },
    "GN": { "emoji": "🇬🇳", "unicode": "U+1F1EC U+1F1F3" },
    "GP": { "emoji": "🇬🇵", "unicode": "U+1F1EC U+1F1F5" },
    "GQ": { "emoji": "🇬🇶", "unicode": "U+1F1EC U+1F1F6" },
    "GR": { "emoji": "🇬🇷", "unicode": "U+1F1EC U+1F1F7" },
    "GS": { "emoji": "🇬🇸", "unicode": "U+1F1EC U+1F1F8" },
    "GT": { "emoji": "🇬🇹", "unicode": "U+1F1EC U+1F1F9" },
    "GU": { "emoji": "🇬🇺", "unicode": "U+1F1EC U+1F1FA" },
    "GW": { "emoji": "🇬🇼", "unicode": "U+1F1EC U+1F1FC" },
    "GY": { "emoji": "🇬🇾", "unicode": "U+1F1EC U+1F1FE" },
    "HK": { "emoji": "🇭🇰", "unicode": "U+1F1ED U+1F1F0" },
    "HM": { "emoji": "🇭🇲", "unicode": "U+1F1ED U+1F1F2" },
    "HN": { "emoji": "🇭🇳", "unicode": "U+1F1ED U+1F1F3" },
    "HR": { "emoji": "🇭🇷", "unicode": "U+1F1ED U+1F1F7" },
    "HT": { "emoji": "🇭🇹", "unicode": "U+1F1ED U+1F1F9" },
    "HU": { "emoji": "🇭🇺", "unicode": "U+1F1ED U+1F1FA" },
    "ID": { "emoji": "🇮🇩", "unicode": "U+1F1EE U+1F1E9" },
    "IE": { "emoji": "🇮🇪", "unicode": "U+1F1EE U+1F1EA" },
    "IL": { "emoji": "🇮🇱", "unicode": "U+1F1EE U+1F1F1" },
    "IM": { "emoji": "🇮🇲", "unicode": "U+1F1EE U+1F1F2" },
    "IN": { "emoji": "🇮🇳", "unicode": "U+1F1EE U+1F1F3" },
    "IO": { "emoji": "🇮🇴", "unicode": "U+1F1EE U+1F1F4" },
    "IQ": { "emoji": "🇮🇶", "unicode": "U+1F1EE U+1F1F6" },
    "IR": { "emoji": "🇮🇷", "unicode": "U+1F1EE U+1F1F7" },
    "IS": { "emoji": "🇮🇸", "unicode": "U+1F1EE U+1F1F8" },
    "IT": { "emoji": "🇮🇹", "unicode": "U+1F1EE U+1F1F9" },
    "JE": { "emoji": "🇯🇪", "unicode": "U+1F1EF U+1F1EA" },
    "JM": { "emoji": "🇯🇲", "unicode": "U+1F1EF U+1F1F2" },
    "JO": { "emoji": "🇯🇴", "unicode": "U+1F1EF U+1F1F4" },
    "JP": { "emoji": "🇯🇵", "unicode": "U+1F1EF U+1F1F5" },
    "KE": { "emoji": "🇰🇪", "unicode": "U+1F1F0 U+1F1EA" },
    "KG": { "emoji": "🇰🇬", "unicode": "U+1F1F0 U+1F1EC" },
    "KH": { "emoji": "🇰🇭", "unicode": "U+1F1F0 U+1F1ED" },
    "KI": { "emoji": "🇰🇮", "unicode": "U+1F1F0 U+1F1EE" },
    "KM": { "emoji": "🇰🇲", "unicode": "U+1F1F0 U+1F1F2" },
    "KN": { "emoji": "🇰🇳", "unicode": "U+1F1F0 U+1F1F3" },
    "KP": { "emoji": "🇰🇵", "unicode": "U+1F1F0 U+1F1F5" },
    "KR": { "emoji": "🇰🇷", "unicode": "U+1F1F0 U+1F1F7" },
    "KW": { "emoji": "🇰🇼", "unicode": "U+1F1F0 U+1F1FC" },
    "KY": { "emoji": "🇰🇾", "unicode": "U+1F1F0 U+1F1FE" },
    "KZ": { "emoji": "🇰🇿", "unicode": "U+1F1F0 U+1F1FF" },
    "LA": { "emoji": "🇱🇦", "unicode": "U+1F1F1 U+1F1E6" },
    "LB": { "emoji": "🇱🇧", "unicode": "U+1F1F1 U+1F1E7" },
    "LC": { "emoji": "🇱🇨", "unicode": "U+1F1F1 U+1F1E8" },
    "LI": { "emoji": "🇱🇮", "unicode": "U+1F1F1 U+1F1EE" },
    "LK": { "emoji": "🇱🇰", "unicode": "U+1F1F1 U+1F1F0" },
    "LR": { "emoji": "🇱🇷", "unicode": "U+1F1F1 U+1F1F7" },
    "LS": { "emoji": "🇱🇸", "unicode": "U+1F1F1 U+1F1F8" },
    "LT": { "emoji": "🇱🇹", "unicode": "U+1F1F1 U+1F1F9" },
    "LU": { "emoji": "🇱🇺", "unicode": "U+1F1F1 U+1F1FA" },
    "LV": { "emoji": "🇱🇻", "unicode": "U+1F1F1 U+1F1FB" },
    "LY": { "emoji": "🇱🇾", "unicode": "U+1F1F1 U+1F1FE" },
    "MA": { "emoji": "🇲🇦", "unicode": "U+1F1F2 U+1F1E6" },
    "MC": { "emoji": "🇲🇨", "unicode": "U+1F1F2 U+1F1E8" },
    "MD": { "emoji": "🇲🇩", "unicode": "U+1F1F2 U+1F1E9" },
    "ME": { "emoji": "🇲🇪", "unicode": "U+1F1F2 U+1F1EA" },
    "MF": { "emoji": "🇲🇫", "unicode": "U+1F1F2 U+1F1EB" },
    "MG": { "emoji": "🇲🇬", "unicode": "U+1F1F2 U+1F1EC" },
    "MH": { "emoji": "🇲🇭", "unicode": "U+1F1F2 U+1F1ED" },
    "MK": { "emoji": "🇲🇰", "unicode": "U+1F1F2 U+1F1F0" },
    "ML": { "emoji": "🇲🇱", "unicode": "U+1F1F2 U+1F1F1" },
    "MM": { "emoji": "🇲🇲", "unicode": "U+1F1F2 U+1F1F2" },
    "MN": { "emoji": "🇲🇳", "unicode": "U+1F1F2 U+1F1F3" },
    "MO": { "emoji": "🇲🇴", "unicode": "U+1F1F2 U+1F1F4" },
    "MP": { "emoji": "🇲🇵", "unicode": "U+1F1F2 U+1F1F5" },
    "MQ": { "emoji": "🇲🇶", "unicode": "U+1F1F2 U+1F1F6" },
    "MR": { "emoji": "🇲🇷", "unicode": "U+1F1F2 U+1F1F7" },
    "MS": { "emoji": "🇲🇸", "unicode": "U+1F1F2 U+1F1F8" },
    "MT": { "emoji": "🇲🇹", "unicode": "U+1F1F2 U+1F1F9" },
    "MU": { "emoji": "🇲🇺", "unicode": "U+1F1F2 U+1F1FA" },
    "MV": { "emoji": "🇲🇻", "unicode": "U+1F1F2 U+1F1FB" },
    "MW": { "emoji": "🇲🇼", "unicode": "U+1F1F2 U+1F1FC" },
    "MX": { "emoji": "🇲🇽", "unicode": "U+1F1F2 U+1F1FD" },
    "MY": { "emoji": "🇲🇾", "unicode": "U+1F1F2 U+1F1FE" },
    "MZ": { "emoji": "🇲🇿", "unicode": "U+1F1F2 U+1F1FF" },
    "NA": { "emoji": "🇳🇦", "unicode": "U+1F1F3 U+1F1E6" },
    "NC": { "emoji": "🇳🇨", "unicode": "U+1F1F3 U+1F1E8" },
    "NE": { "emoji": "🇳🇪", "unicode": "U+1F1F3 U+1F1EA" },
    "NF": { "emoji": "🇳🇫", "unicode": "U+1F1F3 U+1F1EB" },
    "NG": { "emoji": "🇳🇬", "unicode": "U+1F1F3 U+1F1EC" },
    "NI": { "emoji": "🇳🇮", "unicode": "U+1F1F3 U+1F1EE" },
    "NL": { "emoji": "🇳🇱", "unicode": "U+1F1F3 U+1F1F1" },
    "NO": { "emoji": "🇳🇴", "unicode": "U+1F1F3 U+1F1F4" },
    "NP": { "emoji": "🇳🇵", "unicode": "U+1F1F3 U+1F1F5" },
    "NR": { "emoji": "🇳🇷", "unicode": "U+1F1F3 U+1F1F7" },
    "NU": { "emoji": "🇳🇺", "unicode": "U+1F1F3 U+1F1FA" },
    "NZ": { "emoji": "🇳🇿", "unicode": "U+1F1F3 U+1F1FF" },
    "OM": { "emoji": "🇴🇲", "unicode": "U+1F1F4 U+1F1F2" },
    "PA": { "emoji": "🇵🇦", "unicode": "U+1F1F5 U+1F1E6" },
    "PE": { "emoji": "🇵🇪", "unicode": "U+1F1F5 U+1F1EA" },
    "PF": { "emoji": "🇵🇫", "unicode": "U+1F1F5 U+1F1EB" },
    "PG": { "emoji": "🇵🇬", "unicode": "U+1F1F5 U+1F1EC" },
    "PH": { "emoji": "🇵🇭", "unicode": "U+1F1F5 U+1F1ED" },
    "PK": { "emoji": "🇵🇰", "unicode": "U+1F1F5 U+1F1F0" },
    "PL": { "emoji": "🇵🇱", "unicode": "U+1F1F5 U+1F1F1" },
    "PM": { "emoji": "🇵🇲", "unicode": "U+1F1F5 U+1F1F2" },
    "PN": { "emoji": "🇵🇳", "unicode": "U+1F1F5 U+1F1F3" },
    "PR": { "emoji": "🇵🇷", "unicode": "U+1F1F5 U+1F1F7" },
    "PS": { "emoji": "🇵🇸", "unicode": "U+1F1F5 U+1F1F8" },
    "PT": { "emoji": "🇵🇹", "unicode": "U+1F1F5 U+1F1F9" },
    "PW": { "emoji": "🇵🇼", "unicode": "U+1F1F5 U+1F1FC" },
    "PY": { "emoji": "🇵🇾", "unicode": "U+1F1F5 U+1F1FE" },
    "QA": { "emoji": "🇶🇦", "unicode": "U+1F1F6 U+1F1E6" },
    "RE": { "emoji": "🇷🇪", "unicode": "U+1F1F7 U+1F1EA" },
    "RO": { "emoji": "🇷🇴", "unicode": "U+1F1F7 U+1F1F4" },
    "RS": { "emoji": "🇷🇸", "unicode": "U+1F1F7 U+1F1F8" },
    "RU": { "emoji": "🇷🇺", "unicode": "U+1F1F7 U+1F1FA" },
    "RW": { "emoji": "🇷🇼", "unicode": "U+1F1F7 U+1F1FC" },
    "SA": { "emoji": "🇸🇦", "unicode": "U+1F1F8 U+1F1E6" },
    "SB": { "emoji": "🇸🇧", "unicode": "U+1F1F8 U+1F1E7" },
    "SC": { "emoji": "🇸🇨", "unicode": "U+1F1F8 U+1F1E8" },
    "SD": { "emoji": "🇸🇩", "unicode": "U+1F1F8 U+1F1E9" },
    "SE": { "emoji": "🇸🇪", "unicode": "U+1F1F8 U+1F1EA" },
    "SG": { "emoji": "🇸🇬", "unicode": "U+1F1F8 U+1F1EC" },
    "SH": { "emoji": "🇸🇭", "unicode": "U+1F1F8 U+1F1ED" },
    "SI": { "emoji": "🇸🇮", "unicode": "U+1F1F8 U+1F1EE" },
    "SJ": { "emoji": "🇸🇯", "unicode": "U+1F1F8 U+1F1EF" },
    "SK": { "emoji": "🇸🇰", "unicode": "U+1F1F8 U+1F1F0" },
    "SL": { "emoji": "🇸🇱", "unicode": "U+1F1F8 U+1F1F1" },
    "SM": { "emoji": "🇸🇲", "unicode": "U+1F1F8 U+1F1F2" },
    "SN": { "emoji": "🇸🇳", "unicode": "U+1F1F8 U+1F1F3" },
    "SO": { "emoji": "🇸🇴", "unicode": "U+1F1F8 U+1F1F4" },
    "SR": { "emoji": "🇸🇷", "unicode": "U+1F1F8 U+1F1F7" },
    "SS": { "emoji": "🇸🇸", "unicode": "U+1F1F8 U+1F1F8" },
    "ST": { "emoji": "🇸🇹", "unicode": "U+1F1F8 U+1F1F9" },
    "SV": { "emoji": "🇸🇻", "unicode": "U+1F1F8 U+1F1FB" },
    "SX": { "emoji": "🇸🇽", "unicode": "U+1F1F8 U+1F1FD" },
    "SY": { "emoji": "🇸🇾", "unicode": "U+1F1F8 U+1F1FE" },
    "SZ": { "emoji": "🇸🇿", "unicode": "U+1F1F8 U+1F1FF" },
    "TC": { "emoji": "🇹🇨", "unicode": "U+1F1F9 U+1F1E8" },
    "TD": { "emoji": "🇹🇩", "unicode": "U+1F1F9 U+1F1E9" },
    "TF": { "emoji": "🇹🇫", "unicode": "U+1F1F9 U+1F1EB" },
    "TG": { "emoji": "🇹🇬", "unicode": "U+1F1F9 U+1F1EC" },
    "TH": { "emoji": "🇹🇭", "unicode": "U+1F1F9 U+1F1ED" },
    "TJ": { "emoji": "🇹🇯", "unicode": "U+1F1F9 U+1F1EF" },
    "TK": { "emoji": "🇹🇰", "unicode": "U+1F1F9 U+1F1F0" },
    "TL": { "emoji": "🇹🇱", "unicode": "U+1F1F9 U+1F1F1" },
    "TM": { "emoji": "🇹🇲", "unicode": "U+1F1F9 U+1F1F2" },
    "TN": { "emoji": "🇹🇳", "unicode": "U+1F1F9 U+1F1F3" },
    "TO": { "emoji": "🇹🇴", "unicode": "U+1F1F9 U+1F1F4" },
    "TR": { "emoji": "🇹🇷", "unicode": "U+1F1F9 U+1F1F7" },
    "TT": { "emoji": "🇹🇹", "unicode": "U+1F1F9 U+1F1F9" },
    "TV": { "emoji": "🇹🇻", "unicode": "U+1F1F9 U+1F1FB" },
    "TW": { "emoji": "🇹🇼", "unicode": "U+1F1F9 U+1F1FC" },
    "TZ": { "emoji": "🇹🇿", "unicode": "U+1F1F9 U+1F1FF" },
    "UA": { "emoji": "🇺🇦", "unicode": "U+1F1FA U+1F1E6" },
    "UG": { "emoji": "🇺🇬", "unicode": "U+1F1FA U+1F1EC" },
    "UM": { "emoji": "🇺🇲", "unicode": "U+1F1FA U+1F1F2" },
    "US": { "emoji": "🇺🇸", "unicode": "U+1F1FA U+1F1F8" },
    "UY": { "emoji": "🇺🇾", "unicode": "U+1F1FA U+1F1FE" },
    "UZ": { "emoji": "🇺🇿", "unicode": "U+1F1FA U+1F1FF" },
    "VA": { "emoji": "🇻🇦", "unicode": "U+1F1FB U+1F1E6" },
    "VC": { "emoji": "🇻🇨", "unicode": "U+1F1FB U+1F1E8" },
    "VE": { "emoji": "🇻🇪", "unicode": "U+1F1FB U+1F1EA" },
    "VG": { "emoji": "🇻🇬", "unicode": "U+1F1FB U+1F1EC" },
    "VI": { "emoji": "🇻🇮", "unicode": "U+1F1FB U+1F1EE" },
    "VN": { "emoji": "🇻🇳", "unicode": "U+1F1FB U+1F1F3" },
    "VU": { "emoji": "🇻🇺", "unicode": "U+1F1FB U+1F1FA" },
    "WF": { "emoji": "🇼🇫", "unicode": "U+1F1FC U+1F1EB" },
    "WS": { "emoji": "🇼🇸", "unicode": "U+1F1FC U+1F1F8" },
    "XK": { "emoji": "🇽🇰", "unicode": "U+1F1FD U+1F1F0" },
    "YE": { "emoji": "🇾🇪", "unicode": "U+1F1FE U+1F1EA" },
    "YT": { "emoji": "🇾🇹", "unicode": "U+1F1FE U+1F1F9" },
    "ZA": { "emoji": "🇿🇦", "unicode": "U+1F1FF U+1F1E6" },
    "ZM": { "emoji": "🇿🇲", "unicode": "U+1F1FF U+1F1F2" },
    "ZW": { "emoji": "🇿🇼", "unicode": "U+1F1FF U+1F1FC" }
};
exports.defaultEuCountries = ["IE", "AT", "LT", "LU", "LV", "DE", "DK", "SE", "SI", "SK", "CZ", "CY", "NL", "FI", "FR", "MT", "ES", "IT", "EE", "PL", "PT", "HU", "HR", "GR", "RO", "BG", "BE"];


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/src/cache/lruCache.js":
/*!*************************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/src/cache/lruCache.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lru_cache_1 = __importDefault(__webpack_require__(/*! lru-cache */ "./node_modules/node-ipinfo/node_modules/lru-cache/index.js"));
var cacheOptions = {
    max: 5000,
    ttl: 24 * 1000 * 60 * 60
};
var LruCache = (function () {
    function LruCache(option) {
        if (option === void 0) { option = cacheOptions; }
        this.cache = new lru_cache_1.default(option);
    }
    LruCache.prototype.get = function (key) {
        return this.cache.get(key);
    };
    LruCache.prototype.set = function (key, data) {
        this.cache.set(key, data);
    };
    return LruCache;
}());
exports["default"] = LruCache;


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/src/common.js":
/*!*****************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/src/common.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BOGON_NETWORKS = exports.BATCH_REQ_TIMEOUT_DEFAULT = exports.REQUEST_TIMEOUT_DEFAULT = exports.BATCH_MAX_SIZE = exports.CACHE_VSN = exports.HOST = void 0;
exports.HOST = "ipinfo.io";
exports.CACHE_VSN = "1";
exports.BATCH_MAX_SIZE = 1000;
exports.REQUEST_TIMEOUT_DEFAULT = 5000;
exports.BATCH_REQ_TIMEOUT_DEFAULT = 5000;
exports.BOGON_NETWORKS = [
    "0.0.0.0/8",
    "10.0.0.0/8",
    "100.64.0.0/10",
    "127.0.0.0/8",
    "169.254.0.0/16",
    "172.16.0.0/12",
    "192.0.0.0/24",
    "192.0.2.0/24",
    "192.168.0.0/16",
    "198.18.0.0/15",
    "198.51.100.0/24",
    "203.0.113.0/24",
    "224.0.0.0/4",
    "240.0.0.0/4",
    "255.255.255.255/32",
    "::/128",
    "::1/128",
    "::ffff:0:0/96",
    "::/96",
    "100::/64",
    "2001:10::/28",
    "2001:db8::/32",
    "fc00::/7",
    "fe80::/10",
    "fec0::/10",
    "ff00::/8",
    "2002::/24",
    "2002:a00::/24",
    "2002:7f00::/24",
    "2002:a9fe::/32",
    "2002:ac10::/28",
    "2002:c000::/40",
    "2002:c000:200::/40",
    "2002:c0a8::/32",
    "2002:c612::/31",
    "2002:c633:6400::/40",
    "2002:cb00:7100::/40",
    "2002:e000::/20",
    "2002:f000::/20",
    "2002:ffff:ffff::/48",
    "2001::/40",
    "2001:0:a00::/40",
    "2001:0:7f00::/40",
    "2001:0:a9fe::/48",
    "2001:0:ac10::/44",
    "2001:0:c000::/56",
    "2001:0:c000:200::/56",
    "2001:0:c0a8::/48",
    "2001:0:c612::/47",
    "2001:0:c633:6400::/56",
    "2001:0:cb00:7100::/56",
    "2001:0:e000::/36",
    "2001:0:f000::/36",
    "2001:0:ffff:ffff::/64"
];


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/src/errors/apiLimitError.js":
/*!*******************************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/src/errors/apiLimitError.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
var ApiLimitError = (function (_super) {
    __extends(ApiLimitError, _super);
    function ApiLimitError() {
        var _this = _super.call(this, "You have exceeded your total request quota this month. Visit https://ipinfo.io/account to see your API limits.") || this;
        Object.setPrototypeOf(_this, ApiLimitError.prototype);
        return _this;
    }
    return ApiLimitError;
}(Error));
exports["default"] = ApiLimitError;


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/src/index.js":
/*!****************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/src/index.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ApiLimitError = exports.IPinfoWrapper = exports.LruCache = void 0;
var ipinfoWrapper_1 = __importDefault(__webpack_require__(/*! ./ipinfoWrapper */ "./node_modules/node-ipinfo/dist/src/ipinfoWrapper.js"));
exports.IPinfoWrapper = ipinfoWrapper_1.default;
var lruCache_1 = __importDefault(__webpack_require__(/*! ./cache/lruCache */ "./node_modules/node-ipinfo/dist/src/cache/lruCache.js"));
exports.LruCache = lruCache_1.default;
var apiLimitError_1 = __importDefault(__webpack_require__(/*! ./errors/apiLimitError */ "./node_modules/node-ipinfo/dist/src/errors/apiLimitError.js"));
exports.ApiLimitError = apiLimitError_1.default;
exports["default"] = ipinfoWrapper_1.default;


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/src/ipinfoWrapper.js":
/*!************************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/src/ipinfoWrapper.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var node_fetch_1 = __importDefault(__webpack_require__(/*! node-fetch */ "./node_modules/node-fetch/browser.js"));
var utils_1 = __webpack_require__(/*! ../config/utils */ "./node_modules/node-ipinfo/dist/config/utils.js");
var lruCache_1 = __importDefault(__webpack_require__(/*! ./cache/lruCache */ "./node_modules/node-ipinfo/dist/src/cache/lruCache.js"));
var apiLimitError_1 = __importDefault(__webpack_require__(/*! ./errors/apiLimitError */ "./node_modules/node-ipinfo/dist/src/errors/apiLimitError.js"));
var isInSubnet = (__webpack_require__(/*! subnet-check */ "./node_modules/subnet-check/lib/src/index.js").isInSubnet);
var common_1 = __webpack_require__(/*! ./common */ "./node_modules/node-ipinfo/dist/src/common.js");
var version_1 = __importDefault(__webpack_require__(/*! ./version */ "./node_modules/node-ipinfo/dist/src/version.js"));
var clientUserAgent = "IPinfoClient/nodejs/".concat(version_1.default);
var countryFlagURL = "https://cdn.ipinfo.io/static/images/countries-flags/";
var IPinfoWrapper = (function () {
    function IPinfoWrapper(token, cache, timeout, i18nData, baseUrl) {
        this.mapLimitErrorMessage = "You have exceeded maximum IP upload limit per request.";
        this.token = token;
        this.countries = (i18nData === null || i18nData === void 0 ? void 0 : i18nData.countries)
            ? i18nData.countries
            : utils_1.defaultCountries;
        this.countriesFlags = (i18nData === null || i18nData === void 0 ? void 0 : i18nData.countriesFlags)
            ? i18nData.countriesFlags
            : utils_1.defaultCountriesFlags;
        this.countriesCurrencies = (i18nData === null || i18nData === void 0 ? void 0 : i18nData.countriesCurrencies)
            ? i18nData.countriesCurrencies
            : utils_1.defaultCountriesCurrencies;
        this.continents = (i18nData === null || i18nData === void 0 ? void 0 : i18nData.continents)
            ? i18nData.continents
            : utils_1.defaultContinents;
        this.euCountries =
            (i18nData === null || i18nData === void 0 ? void 0 : i18nData.euCountries) && (i18nData === null || i18nData === void 0 ? void 0 : i18nData.euCountries.length) !== 0
                ? i18nData.euCountries
                : utils_1.defaultEuCountries;
        this.cache = cache ? cache : new lruCache_1.default();
        this.timeout =
            timeout === null || timeout === undefined
                ? common_1.REQUEST_TIMEOUT_DEFAULT
                : timeout;
        this.baseUrl = baseUrl || "https://".concat(common_1.HOST);
    }
    IPinfoWrapper.cacheKey = function (k) {
        return "".concat(k, ":").concat(common_1.CACHE_VSN);
    };
    IPinfoWrapper.prototype.fetchApi = function (path_1) {
        return __awaiter(this, arguments, void 0, function (path, init) {
            var headers, request, url;
            if (init === void 0) { init = {}; }
            return __generator(this, function (_a) {
                headers = {
                    Accept: "application/json",
                    Authorization: "Bearer ".concat(this.token),
                    "Content-Type": "application/json",
                    "User-Agent": clientUserAgent
                };
                request = Object.assign({
                    timeout: this.timeout,
                    method: "GET",
                    compress: false
                }, init, { headers: Object.assign(headers, init.headers) });
                url = [this.baseUrl, path].join(!this.baseUrl.endsWith("/") && !path.startsWith("/") ? "/" : "");
                return [2, (0, node_fetch_1.default)(url, request).then(function (response) {
                        if (response.status === 429) {
                            throw new apiLimitError_1.default();
                        }
                        if (response.status >= 400) {
                            throw new Error("Received an error from the IPinfo API " +
                                "(using authorization ".concat(headers["Authorization"], ") ") +
                                "".concat(response.status, " ").concat(response.statusText, " ").concat(response.url));
                        }
                        return response;
                    })];
            });
        });
    };
    IPinfoWrapper.prototype.lookupIp = function (ip) {
        return __awaiter(this, void 0, void 0, function () {
            var ipinfo, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isBogon(ip)) {
                            ipinfo = {};
                            ipinfo.bogon = true;
                            ipinfo.ip = ip;
                            return [2, ipinfo];
                        }
                        return [4, this.cache.get(IPinfoWrapper.cacheKey(ip))];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            return [2, data];
                        }
                        return [2, this.fetchApi("".concat(ip, "/json")).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var ipinfo;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, response.json()];
                                        case 1:
                                            ipinfo = (_a.sent());
                                            if (ipinfo.country) {
                                                ipinfo.countryCode = ipinfo.country;
                                                ipinfo.country = this.countries[ipinfo.countryCode];
                                                ipinfo.countryFlag = this.countriesFlags[ipinfo.countryCode];
                                                ipinfo.countryFlagURL =
                                                    countryFlagURL + ipinfo.countryCode + ".svg";
                                                ipinfo.countryCurrency =
                                                    this.countriesCurrencies[ipinfo.countryCode];
                                                ipinfo.continent = this.continents[ipinfo.countryCode];
                                                ipinfo.isEU = this.euCountries.includes(ipinfo.countryCode);
                                            }
                                            if (ipinfo.abuse && ipinfo.abuse.country) {
                                                ipinfo.abuse.countryCode = ipinfo.abuse.country;
                                                ipinfo.abuse.country =
                                                    this.countries[ipinfo.abuse.countryCode];
                                            }
                                            this.cache.set(IPinfoWrapper.cacheKey(ip), ipinfo);
                                            return [2, ipinfo];
                                    }
                                });
                            }); })];
                }
            });
        });
    };
    IPinfoWrapper.prototype.lookupASN = function (asn) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.cache.get(IPinfoWrapper.cacheKey(asn))];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            return [2, data];
                        }
                        return [2, this.fetchApi("".concat(asn, "/json")).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var asnResp;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, response.json()];
                                        case 1:
                                            asnResp = (_a.sent());
                                            if (asnResp.country) {
                                                asnResp.countryCode = asnResp.country;
                                                asnResp.country = this.countries[asnResp.countryCode];
                                            }
                                            this.cache.set(IPinfoWrapper.cacheKey(asn), asnResp);
                                            return [2, asnResp];
                                    }
                                });
                            }); })];
                }
            });
        });
    };
    IPinfoWrapper.prototype.getMap = function (ips) {
        var _this = this;
        if (ips.length > 500000) {
            return new Promise(function (_resolve, reject) {
                reject(new Error(_this.mapLimitErrorMessage));
            });
        }
        return this.fetchApi("/tools/map?cli=1", {
            method: "POST",
            body: JSON.stringify(ips)
        }).then(function (response) { return response.json(); });
    };
    IPinfoWrapper.prototype.__getBatch = function (ips, batchTimeout, filter) {
        var _this = this;
        return this.fetchApi("batch".concat(filter ? "?filter=1" : ""), {
            Accept: "application/json",
            headers: {
                "Content-Type": "application/json"
            },
            method: "POST",
            body: JSON.stringify(ips),
            timeout: batchTimeout
        }).then(function (response) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, response.json()];
                case 1: return [2, _a.sent()];
            }
        }); }); });
    };
    IPinfoWrapper.prototype.getBatch = function (urls_1) {
        return __awaiter(this, arguments, void 0, function (urls, batchSize, batchTimeout, timeoutTotal, filter) {
            var result, lookupUrls, _i, urls_2, url, cachedUrl, promises, i, end, resDetails, batchPromise, totalTimeoutReached, totalTimeoutRef, timeoutPromise;
            var _this = this;
            if (batchSize === void 0) { batchSize = common_1.BATCH_MAX_SIZE; }
            if (batchTimeout === void 0) { batchTimeout = common_1.BATCH_REQ_TIMEOUT_DEFAULT; }
            if (timeoutTotal === void 0) { timeoutTotal = 0; }
            if (filter === void 0) { filter = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = {};
                        if (urls.length == 0) {
                            return [2, result];
                        }
                        if (batchSize <= 0 || batchSize > common_1.BATCH_MAX_SIZE) {
                            batchSize = common_1.BATCH_MAX_SIZE;
                        }
                        lookupUrls = [];
                        _i = 0, urls_2 = urls;
                        _a.label = 1;
                    case 1:
                        if (!(_i < urls_2.length)) return [3, 4];
                        url = urls_2[_i];
                        return [4, this.cache.get(IPinfoWrapper.cacheKey(url))];
                    case 2:
                        cachedUrl = _a.sent();
                        if (cachedUrl) {
                            result[url] = cachedUrl;
                        }
                        else {
                            lookupUrls.push(url);
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4:
                        if (lookupUrls.length == 0) {
                            return [2, result];
                        }
                        promises = [];
                        for (i = 0; i < lookupUrls.length; i += batchSize) {
                            end = i + batchSize;
                            if (end > lookupUrls.length) {
                                end = lookupUrls.length;
                            }
                            resDetails = this.__getBatch(lookupUrls.slice(i, end), batchTimeout, filter);
                            promises.push(resDetails);
                        }
                        batchPromise = Promise.all(promises).then(function (values) {
                            values.forEach(function (el) {
                                var batchResp;
                                try {
                                    batchResp = el;
                                }
                                catch (_a) {
                                    batchResp = {};
                                }
                                for (var key in batchResp) {
                                    if (batchResp.hasOwnProperty(key)) {
                                        var ipinfo = batchResp[key];
                                        if (ipinfo.country) {
                                            ipinfo.countryCode = ipinfo.country;
                                            ipinfo.country =
                                                _this.countries[ipinfo.countryCode];
                                        }
                                        if (ipinfo.abuse && ipinfo.abuse.country) {
                                            ipinfo.abuse.countryCode = ipinfo.abuse.country;
                                            ipinfo.abuse.country =
                                                _this.countries[ipinfo.abuse.countryCode];
                                        }
                                        if (!ipinfo.error) {
                                            _this.cache.set(IPinfoWrapper.cacheKey(key), ipinfo);
                                        }
                                        result[key] = batchResp[key];
                                    }
                                }
                            });
                        });
                        totalTimeoutReached = Symbol();
                        timeoutPromise = new Promise(function (resolve) {
                            if (timeoutTotal > 0) {
                                totalTimeoutRef = setTimeout(resolve, timeoutTotal, totalTimeoutReached);
                            }
                        });
                        return [4, Promise.race([batchPromise, timeoutPromise]).then(function (value) {
                                return new Promise(function (resolve, reject) {
                                    if (value === totalTimeoutReached) {
                                        reject(new Error("Total timeout has been exceeded."));
                                    }
                                    else {
                                        if (totalTimeoutRef) {
                                            clearTimeout(totalTimeoutRef);
                                        }
                                        resolve(result);
                                    }
                                });
                            })];
                    case 5: return [2, _a.sent()];
                }
            });
        });
    };
    IPinfoWrapper.prototype.isBogon = function (ip) {
        if (ip != "") {
            for (var _i = 0, BOGON_NETWORKS_1 = common_1.BOGON_NETWORKS; _i < BOGON_NETWORKS_1.length; _i++) {
                var network = BOGON_NETWORKS_1[_i];
                if (isInSubnet(ip, network)) {
                    return true;
                }
            }
        }
        return false;
    };
    return IPinfoWrapper;
}());
exports["default"] = IPinfoWrapper;


/***/ }),

/***/ "./node_modules/node-ipinfo/dist/src/version.js":
/*!******************************************************!*\
  !*** ./node_modules/node-ipinfo/dist/src/version.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var VERSION = "4.0.0";
exports["default"] = VERSION;


/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/subnet-check/lib/src/index.js":
/*!****************************************************!*\
  !*** ./node_modules/subnet-check/lib/src/index.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var IPv4 = __webpack_require__(/*! ./ipv4 */ "./node_modules/subnet-check/lib/src/ipv4.js");
exports.IPv4 = IPv4;
var IPv6 = __webpack_require__(/*! ./ipv6 */ "./node_modules/subnet-check/lib/src/ipv6.js");
exports.IPv6 = IPv6;
var net_1 = __webpack_require__(/*! ./net */ "./node_modules/subnet-check/lib/src/net.js");
exports.isIPv4 = net_1.isIPv4;
exports.isIPv6 = net_1.isIPv6;
/**
 * Test if the given IP address is contained in the specified subnet.
 * @param address the IPv4 or IPv6 address to check
 * @param subnet the IPv4 or IPv6 CIDR to test (or an array of them)
 * @throws if the address or subnet are not valid IP addresses, or the CIDR prefix length
 *  is not valid
 */
function isInSubnet(address, subnetOrSubnets) {
    if (!Array.isArray(subnetOrSubnets)) {
        return isInSubnet(address, [subnetOrSubnets]);
    }
    // for mapped IPv4 addresses, compare against both IPv6 and IPv4 subnets
    if (net_1.isIPv6(address) && IPv6.isIPv4MappedAddress(address)) {
        return (IPv6.isInSubnet(address, subnetOrSubnets.filter(function (subnet) { return net_1.isIPv6(subnet.split('/')[0]); })) ||
            IPv4.isInSubnet(IPv6.extractMappedIpv4(address), subnetOrSubnets.filter(function (subnet) { return net_1.isIPv4(subnet.split('/')[0]); })));
    }
    if (net_1.isIPv6(address)) {
        return IPv6.isInSubnet(address, subnetOrSubnets.filter(function (subnet) { return net_1.isIPv6(subnet.split('/')[0]); }));
    }
    else {
        return IPv4.isInSubnet(address, subnetOrSubnets.filter(function (subnet) { return net_1.isIPv4(subnet.split('/')[0]); }));
    }
}
exports.isInSubnet = isInSubnet;
/** Test if the given IP address is a private/internal IP address. */
function isPrivate(address) {
    if (net_1.isIPv6(address)) {
        if (IPv6.isIPv4MappedAddress(address)) {
            return IPv4.isPrivate(IPv6.extractMappedIpv4(address));
        }
        return IPv6.isPrivate(address);
    }
    else {
        return IPv4.isPrivate(address);
    }
}
exports.isPrivate = isPrivate;
/** Test if the given IP address is a localhost address. */
function isLocalhost(address) {
    if (net_1.isIPv6(address)) {
        if (IPv6.isIPv4MappedAddress(address)) {
            return IPv4.isLocalhost(IPv6.extractMappedIpv4(address));
        }
        return IPv6.isLocalhost(address);
    }
    else {
        return IPv4.isLocalhost(address);
    }
}
exports.isLocalhost = isLocalhost;
/** Test if the given IP address is an IPv4 address mapped onto IPv6 */
function isIPv4MappedAddress(address) {
    if (net_1.isIPv6(address)) {
        return IPv6.isIPv4MappedAddress(address);
    }
    else {
        return false;
    }
}
exports.isIPv4MappedAddress = isIPv4MappedAddress;
/** Test if the given IP address is in a known reserved range and not a normal host IP */
function isReserved(address) {
    if (net_1.isIPv6(address)) {
        if (IPv6.isIPv4MappedAddress(address)) {
            return IPv4.isReserved(IPv6.extractMappedIpv4(address));
        }
        return IPv6.isReserved(address);
    }
    else {
        return IPv4.isReserved(address);
    }
}
exports.isReserved = isReserved;
/**
 * Test if the given IP address is a special address of any kind (private, reserved,
 * localhost)
 */
function isSpecial(address) {
    if (net_1.isIPv6(address)) {
        if (IPv6.isIPv4MappedAddress(address)) {
            return IPv4.isSpecial(IPv6.extractMappedIpv4(address));
        }
        return IPv6.isSpecial(address);
    }
    else {
        return IPv4.isSpecial(address);
    }
}
exports.isSpecial = isSpecial;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/subnet-check/lib/src/ipv4.js":
/*!***************************************************!*\
  !*** ./node_modules/subnet-check/lib/src/ipv4.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var net = __webpack_require__(/*! ./net */ "./node_modules/subnet-check/lib/src/net.js");
/**
 * Given an IPv4 address, convert it to a 32-bit long integer.
 * @param ip the IPv4 address to expand
 * @throws if the string is not a valid IPv4 address
 */
function ipv4ToLong(ip) {
    if (!net.isIPv4(ip)) {
        throw new Error("not a valid IPv4 address: " + ip);
    }
    var octets = ip.split('.');
    return (((parseInt(octets[0], 10) << 24) +
        (parseInt(octets[1], 10) << 16) +
        (parseInt(octets[2], 10) << 8) +
        parseInt(octets[3], 10)) >>>
        0);
}
/**
 * Test if the given IPv4 address is contained in the specified subnet.
 * @param address the IPv4 address to check
 * @param subnet the IPv4 CIDR to test (or an array of them)
 * @throws if the address or subnet are not valid IP addresses, or the CIDR prefix length
 *  is not valid
 */
function isInSubnet(address, subnetOrSubnets) {
    if (Array.isArray(subnetOrSubnets)) {
        return subnetOrSubnets.some(function (subnet) { return isInSubnet(address, subnet); });
    }
    var subnet = subnetOrSubnets;
    var _a = subnet.split('/'), subnetAddress = _a[0], prefixLengthString = _a[1];
    var prefixLength = parseInt(prefixLengthString, 10);
    if (!subnetAddress || !Number.isInteger(prefixLength)) {
        throw new Error("not a valid IPv4 subnet: " + subnet);
    }
    if (prefixLength < 0 || prefixLength > 32) {
        throw new Error("not a valid IPv4 prefix length: " + prefixLength + " (from " + subnet + ")");
    }
    // the next two lines throw if the addresses are not valid IPv4 addresses
    var subnetLong = ipv4ToLong(subnetAddress);
    var addressLong = ipv4ToLong(address);
    if (prefixLength === 0) {
        return true;
    }
    var subnetPrefix = subnetLong >> (32 - prefixLength);
    var addressPrefix = addressLong >> (32 - prefixLength);
    return subnetPrefix === addressPrefix;
}
exports.isInSubnet = isInSubnet;
/** Test if the given IP address is a private/internal IP address. */
function isPrivate(address) {
    return isInSubnet(address, ['10.0.0.0/8', '172.16.0.0/12', '192.168.0.0/16']);
}
exports.isPrivate = isPrivate;
/** Test if the given IP address is a localhost address. */
function isLocalhost(address) {
    return isInSubnet(address, '127.0.0.0/8');
}
exports.isLocalhost = isLocalhost;
/** Test if the given IP address is in a known reserved range and not a normal host IP */
function isReserved(address) {
    return isInSubnet(address, [
        '0.0.0.0/8',
        '100.64.0.0/10',
        '169.254.0.0/16',
        '192.0.0.0/24',
        '192.0.2.0/24',
        '192.88.99.0/24',
        '198.18.0.0/15',
        '198.51.100.0/24',
        '203.0.113.0/24',
        '224.0.0.0/4',
        '240.0.0.0/4',
        '255.255.255.255/32' // limited broadcast address
    ]);
}
exports.isReserved = isReserved;
/**
 * Test if the given IP address is a special address of any kind (private, reserved,
 * localhost)
 */
function isSpecial(address) {
    return isPrivate(address) || isLocalhost(address) || isReserved(address);
}
exports.isSpecial = isSpecial;
//# sourceMappingURL=ipv4.js.map

/***/ }),

/***/ "./node_modules/subnet-check/lib/src/ipv6.js":
/*!***************************************************!*\
  !*** ./node_modules/subnet-check/lib/src/ipv6.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var net = __webpack_require__(/*! ./net */ "./node_modules/subnet-check/lib/src/net.js");
// Note: Profiling shows that on recent versions of Node, string.split(RegExp) is faster
// than string.split(string).
var dot = /\./;
var mappedIpv4 = /^(.+:ffff:)(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?:%.+)?$/;
var colon = /:/;
var doubleColon = /::/;
/**
 * Given a mapped IPv4 address (e.g. ::ffff:203.0.113.38 or similar), convert it to the
 * equivalent standard IPv6 address.
 * @param ip the IPv4-to-IPv6 mapped address
 */
function mappedIpv4ToIpv6(ip) {
    var matches = ip.match(mappedIpv4);
    if (!matches || !net.isIPv4(matches[2])) {
        throw new Error("not a mapped IPv4 address: " + ip);
    }
    // mapped IPv4 address
    var prefix = matches[1];
    var ipv4 = matches[2];
    var parts = ipv4.split(dot).map(function (x) { return parseInt(x, 10); });
    var segment7 = ((parts[0] << 8) + parts[1]).toString(16);
    var segment8 = ((parts[2] << 8) + parts[3]).toString(16);
    return "" + prefix + segment7 + ":" + segment8;
}
/**
 * Given a mapped IPv4 address, return the bare IPv4 equivalent.
 */
function extractMappedIpv4(ip) {
    var matches = ip.match(mappedIpv4);
    if (!matches || !net.isIPv4(matches[2])) {
        throw new Error("not a mapped IPv4 address: " + ip);
    }
    return matches[2];
}
exports.extractMappedIpv4 = extractMappedIpv4;
/**
 * Given an IP address that may have double-colons, expand all segments and return them
 * as an array of 8 segments (16-bit words). As a peformance enhancement (indicated by
 * profiling), for any segment that was missing but should be a '0', returns undefined.
 * @param ip the IPv6 address to expand
 * @throws if the string is not a valid IPv6 address
 */
function getIpv6Segments(ip) {
    if (!net.isIPv6(ip)) {
        throw new Error("not a valid IPv6 address: " + ip);
    }
    if (dot.test(ip)) {
        return getIpv6Segments(mappedIpv4ToIpv6(ip));
    }
    // break it into an array, including missing "::" segments
    var _a = ip.split(doubleColon), beforeChunk = _a[0], afterChunk = _a[1];
    var beforeParts = (beforeChunk && beforeChunk.split(colon)) || [];
    var afterParts = (afterChunk && afterChunk.split(colon)) || [];
    var missingSegments = new Array(8 - (beforeParts.length + afterParts.length));
    return beforeParts.concat(missingSegments, afterParts);
}
/**
 * Test if the given IPv6 address is contained in the specified subnet.
 * @param address the IPv6 address to check
 * @param subnet the IPv6 CIDR to test (or an array of them)
 * @throws if the address or subnet are not valid IP addresses, or the CIDR prefix length
 *  is not valid
 */
function isInSubnet(address, subnetOrSubnets) {
    if (Array.isArray(subnetOrSubnets)) {
        return subnetOrSubnets.some(function (subnet) { return isInSubnet(address, subnet); });
    }
    var subnet = subnetOrSubnets;
    var _a = subnet.split('/'), subnetAddress = _a[0], prefixLengthString = _a[1];
    var prefixLength = parseInt(prefixLengthString, 10);
    if (!subnetAddress || !Number.isInteger(prefixLength)) {
        throw new Error("not a valid IPv6 CIDR subnet: " + subnet);
    }
    if (prefixLength < 0 || prefixLength > 128) {
        throw new Error("not a valid IPv6 prefix length: " + prefixLength + " (from " + subnet + ")");
    }
    // the next two lines throw if the addresses are not valid IPv6 addresses
    var addressSegments = getIpv6Segments(address);
    var subnetSegments = getIpv6Segments(subnetAddress);
    for (var i = 0; i < 8; ++i) {
        var bitCount = Math.min(prefixLength - i * 16, 16);
        if (bitCount <= 0) {
            break;
        }
        var subnetPrefix = ((subnetSegments[i] && parseInt(subnetSegments[i], 16)) || 0) >> (16 - bitCount);
        var addressPrefix = ((addressSegments[i] && parseInt(addressSegments[i], 16)) || 0) >> (16 - bitCount);
        if (subnetPrefix !== addressPrefix) {
            return false;
        }
    }
    return true;
}
exports.isInSubnet = isInSubnet;
/** Test if the given IP address is a private/internal IP address. */
function isPrivate(address) {
    return isInSubnet(address, [
        'fe80::/10',
        'fc00::/7' // unique local address
    ]);
}
exports.isPrivate = isPrivate;
/** Test if the given IP address is a localhost address. */
function isLocalhost(address) {
    return isInSubnet(address, '::1/128');
}
exports.isLocalhost = isLocalhost;
/** Test if the given IP address is an IPv4 address mapped onto IPv6 */
function isIPv4MappedAddress(address) {
    if (isInSubnet(address, '::ffff:0:0/96')) {
        var matches = address.match(mappedIpv4);
        return Boolean(matches && net.isIPv4(matches[2]));
    }
    return false;
}
exports.isIPv4MappedAddress = isIPv4MappedAddress;
/** Test if the given IP address is in a known reserved range and not a normal host IP */
function isReserved(address) {
    return isInSubnet(address, [
        '::/128',
        '64:ff9b::/96',
        '100::/64',
        '2001::/32',
        '2001:10::/28',
        '2001:20::/28',
        '2001:db8::/32',
        '2002::/16',
        'ff00::/8' // multicast
    ]);
}
exports.isReserved = isReserved;
/**
 * Test if the given IP address is a special address of any kind (private, reserved,
 * localhost)
 */
function isSpecial(address) {
    return isPrivate(address) || isLocalhost(address) || isReserved(address);
}
exports.isSpecial = isSpecial;
//# sourceMappingURL=ipv6.js.map

/***/ }),

/***/ "./node_modules/subnet-check/lib/src/net.js":
/*!**************************************************!*\
  !*** ./node_modules/subnet-check/lib/src/net.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// IPv4 Segment
var v4Seg = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var v4Str = "(" + v4Seg + "[.]){3}" + v4Seg;
var IPv4Reg = new RegExp("^" + v4Str + "$");
// IPv6 Segment
var v6Seg = '(?:[0-9a-fA-F]{1,4})';
var IPv6Reg = new RegExp('^(' +
    ("(?:" + v6Seg + ":){7}(?:" + v6Seg + "|:)|") +
    ("(?:" + v6Seg + ":){6}(?:" + v4Str + "|:" + v6Seg + "|:)|") +
    ("(?:" + v6Seg + ":){5}(?::" + v4Str + "|(:" + v6Seg + "){1,2}|:)|") +
    ("(?:" + v6Seg + ":){4}(?:(:" + v6Seg + "){0,1}:" + v4Str + "|(:" + v6Seg + "){1,3}|:)|") +
    ("(?:" + v6Seg + ":){3}(?:(:" + v6Seg + "){0,2}:" + v4Str + "|(:" + v6Seg + "){1,4}|:)|") +
    ("(?:" + v6Seg + ":){2}(?:(:" + v6Seg + "){0,3}:" + v4Str + "|(:" + v6Seg + "){1,5}|:)|") +
    ("(?:" + v6Seg + ":){1}(?:(:" + v6Seg + "){0,4}:" + v4Str + "|(:" + v6Seg + "){1,6}|:)|") +
    ("(?::((?::" + v6Seg + "){0,5}:" + v4Str + "|(?::" + v6Seg + "){1,7}|:))") +
    ')(%[0-9a-zA-Z]{1,})?$');
function isIPv4(s) {
    return IPv4Reg.test(s);
}
exports.isIPv4 = isIPv4;
function isIPv6(s) {
    return IPv6Reg.test(s);
}
exports.isIPv6 = isIPv6;
//# sourceMappingURL=net.js.map

/***/ }),

/***/ "./node_modules/node-ipinfo/node_modules/lru-cache/index.js":
/*!******************************************************************!*\
  !*** ./node_modules/node-ipinfo/node_modules/lru-cache/index.js ***!
  \******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__(/*! process/browser.js */ "./node_modules/process/browser.js");
const perf =
  typeof performance === 'object' &&
  performance &&
  typeof performance.now === 'function'
    ? performance
    : Date

const hasAbortController = typeof AbortController === 'function'

// minimal backwards-compatibility polyfill
// this doesn't have nearly all the checks and whatnot that
// actual AbortController/Signal has, but it's enough for
// our purposes, and if used properly, behaves the same.
const AC = hasAbortController
  ? AbortController
  : class AbortController {
      constructor() {
        this.signal = new AS()
      }
      abort(reason = new Error('This operation was aborted')) {
        this.signal.reason = this.signal.reason || reason
        this.signal.aborted = true
        this.signal.dispatchEvent({
          type: 'abort',
          target: this.signal,
        })
      }
    }

const hasAbortSignal = typeof AbortSignal === 'function'
// Some polyfills put this on the AC class, not global
const hasACAbortSignal = typeof AC.AbortSignal === 'function'
const AS = hasAbortSignal
  ? AbortSignal
  : hasACAbortSignal
  ? AC.AbortController
  : class AbortSignal {
      constructor() {
        this.reason = undefined
        this.aborted = false
        this._listeners = []
      }
      dispatchEvent(e) {
        if (e.type === 'abort') {
          this.aborted = true
          this.onabort(e)
          this._listeners.forEach(f => f(e), this)
        }
      }
      onabort() {}
      addEventListener(ev, fn) {
        if (ev === 'abort') {
          this._listeners.push(fn)
        }
      }
      removeEventListener(ev, fn) {
        if (ev === 'abort') {
          this._listeners = this._listeners.filter(f => f !== fn)
        }
      }
    }

const warned = new Set()
const deprecatedOption = (opt, instead) => {
  const code = `LRU_CACHE_OPTION_${opt}`
  if (shouldWarn(code)) {
    warn(code, `${opt} option`, `options.${instead}`, LRUCache)
  }
}
const deprecatedMethod = (method, instead) => {
  const code = `LRU_CACHE_METHOD_${method}`
  if (shouldWarn(code)) {
    const { prototype } = LRUCache
    const { get } = Object.getOwnPropertyDescriptor(prototype, method)
    warn(code, `${method} method`, `cache.${instead}()`, get)
  }
}
const deprecatedProperty = (field, instead) => {
  const code = `LRU_CACHE_PROPERTY_${field}`
  if (shouldWarn(code)) {
    const { prototype } = LRUCache
    const { get } = Object.getOwnPropertyDescriptor(prototype, field)
    warn(code, `${field} property`, `cache.${instead}`, get)
  }
}

const emitWarning = (...a) => {
  typeof process === 'object' &&
  process &&
  typeof process.emitWarning === 'function'
    ? process.emitWarning(...a)
    : console.error(...a)
}

const shouldWarn = code => !warned.has(code)

const warn = (code, what, instead, fn) => {
  warned.add(code)
  const msg = `The ${what} is deprecated. Please use ${instead} instead.`
  emitWarning(msg, 'DeprecationWarning', code, fn)
}

const isPosInt = n => n && n === Math.floor(n) && n > 0 && isFinite(n)

/* istanbul ignore next - This is a little bit ridiculous, tbh.
 * The maximum array length is 2^32-1 or thereabouts on most JS impls.
 * And well before that point, you're caching the entire world, I mean,
 * that's ~32GB of just integers for the next/prev links, plus whatever
 * else to hold that many keys and values.  Just filling the memory with
 * zeroes at init time is brutal when you get that big.
 * But why not be complete?
 * Maybe in the future, these limits will have expanded. */
const getUintArray = max =>
  !isPosInt(max)
    ? null
    : max <= Math.pow(2, 8)
    ? Uint8Array
    : max <= Math.pow(2, 16)
    ? Uint16Array
    : max <= Math.pow(2, 32)
    ? Uint32Array
    : max <= Number.MAX_SAFE_INTEGER
    ? ZeroArray
    : null

class ZeroArray extends Array {
  constructor(size) {
    super(size)
    this.fill(0)
  }
}

class Stack {
  constructor(max) {
    if (max === 0) {
      return []
    }
    const UintArray = getUintArray(max)
    this.heap = new UintArray(max)
    this.length = 0
  }
  push(n) {
    this.heap[this.length++] = n
  }
  pop() {
    return this.heap[--this.length]
  }
}

class LRUCache {
  constructor(options = {}) {
    const {
      max = 0,
      ttl,
      ttlResolution = 1,
      ttlAutopurge,
      updateAgeOnGet,
      updateAgeOnHas,
      allowStale,
      dispose,
      disposeAfter,
      noDisposeOnSet,
      noUpdateTTL,
      maxSize = 0,
      maxEntrySize = 0,
      sizeCalculation,
      fetchMethod,
      fetchContext,
      noDeleteOnFetchRejection,
      noDeleteOnStaleGet,
      allowStaleOnFetchRejection,
      allowStaleOnFetchAbort,
      ignoreFetchAbort,
    } = options

    // deprecated options, don't trigger a warning for getting them if
    // the thing being passed in is another LRUCache we're copying.
    const { length, maxAge, stale } =
      options instanceof LRUCache ? {} : options

    if (max !== 0 && !isPosInt(max)) {
      throw new TypeError('max option must be a nonnegative integer')
    }

    const UintArray = max ? getUintArray(max) : Array
    if (!UintArray) {
      throw new Error('invalid max value: ' + max)
    }

    this.max = max
    this.maxSize = maxSize
    this.maxEntrySize = maxEntrySize || this.maxSize
    this.sizeCalculation = sizeCalculation || length
    if (this.sizeCalculation) {
      if (!this.maxSize && !this.maxEntrySize) {
        throw new TypeError(
          'cannot set sizeCalculation without setting maxSize or maxEntrySize'
        )
      }
      if (typeof this.sizeCalculation !== 'function') {
        throw new TypeError('sizeCalculation set to non-function')
      }
    }

    this.fetchMethod = fetchMethod || null
    if (this.fetchMethod && typeof this.fetchMethod !== 'function') {
      throw new TypeError(
        'fetchMethod must be a function if specified'
      )
    }

    this.fetchContext = fetchContext
    if (!this.fetchMethod && fetchContext !== undefined) {
      throw new TypeError(
        'cannot set fetchContext without fetchMethod'
      )
    }

    this.keyMap = new Map()
    this.keyList = new Array(max).fill(null)
    this.valList = new Array(max).fill(null)
    this.next = new UintArray(max)
    this.prev = new UintArray(max)
    this.head = 0
    this.tail = 0
    this.free = new Stack(max)
    this.initialFill = 1
    this.size = 0

    if (typeof dispose === 'function') {
      this.dispose = dispose
    }
    if (typeof disposeAfter === 'function') {
      this.disposeAfter = disposeAfter
      this.disposed = []
    } else {
      this.disposeAfter = null
      this.disposed = null
    }
    this.noDisposeOnSet = !!noDisposeOnSet
    this.noUpdateTTL = !!noUpdateTTL
    this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection
    this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection
    this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort
    this.ignoreFetchAbort = !!ignoreFetchAbort

    // NB: maxEntrySize is set to maxSize if it's set
    if (this.maxEntrySize !== 0) {
      if (this.maxSize !== 0) {
        if (!isPosInt(this.maxSize)) {
          throw new TypeError(
            'maxSize must be a positive integer if specified'
          )
        }
      }
      if (!isPosInt(this.maxEntrySize)) {
        throw new TypeError(
          'maxEntrySize must be a positive integer if specified'
        )
      }
      this.initializeSizeTracking()
    }

    this.allowStale = !!allowStale || !!stale
    this.noDeleteOnStaleGet = !!noDeleteOnStaleGet
    this.updateAgeOnGet = !!updateAgeOnGet
    this.updateAgeOnHas = !!updateAgeOnHas
    this.ttlResolution =
      isPosInt(ttlResolution) || ttlResolution === 0
        ? ttlResolution
        : 1
    this.ttlAutopurge = !!ttlAutopurge
    this.ttl = ttl || maxAge || 0
    if (this.ttl) {
      if (!isPosInt(this.ttl)) {
        throw new TypeError(
          'ttl must be a positive integer if specified'
        )
      }
      this.initializeTTLTracking()
    }

    // do not allow completely unbounded caches
    if (this.max === 0 && this.ttl === 0 && this.maxSize === 0) {
      throw new TypeError(
        'At least one of max, maxSize, or ttl is required'
      )
    }
    if (!this.ttlAutopurge && !this.max && !this.maxSize) {
      const code = 'LRU_CACHE_UNBOUNDED'
      if (shouldWarn(code)) {
        warned.add(code)
        const msg =
          'TTL caching without ttlAutopurge, max, or maxSize can ' +
          'result in unbounded memory consumption.'
        emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache)
      }
    }

    if (stale) {
      deprecatedOption('stale', 'allowStale')
    }
    if (maxAge) {
      deprecatedOption('maxAge', 'ttl')
    }
    if (length) {
      deprecatedOption('length', 'sizeCalculation')
    }
  }

  getRemainingTTL(key) {
    return this.has(key, { updateAgeOnHas: false }) ? Infinity : 0
  }

  initializeTTLTracking() {
    this.ttls = new ZeroArray(this.max)
    this.starts = new ZeroArray(this.max)

    this.setItemTTL = (index, ttl, start = perf.now()) => {
      this.starts[index] = ttl !== 0 ? start : 0
      this.ttls[index] = ttl
      if (ttl !== 0 && this.ttlAutopurge) {
        const t = setTimeout(() => {
          if (this.isStale(index)) {
            this.delete(this.keyList[index])
          }
        }, ttl + 1)
        /* istanbul ignore else - unref() not supported on all platforms */
        if (t.unref) {
          t.unref()
        }
      }
    }

    this.updateItemAge = index => {
      this.starts[index] = this.ttls[index] !== 0 ? perf.now() : 0
    }

    this.statusTTL = (status, index) => {
      if (status) {
        status.ttl = this.ttls[index]
        status.start = this.starts[index]
        status.now = cachedNow || getNow()
        status.remainingTTL = status.now + status.ttl - status.start
      }
    }

    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0
    const getNow = () => {
      const n = perf.now()
      if (this.ttlResolution > 0) {
        cachedNow = n
        const t = setTimeout(
          () => (cachedNow = 0),
          this.ttlResolution
        )
        /* istanbul ignore else - not available on all platforms */
        if (t.unref) {
          t.unref()
        }
      }
      return n
    }

    this.getRemainingTTL = key => {
      const index = this.keyMap.get(key)
      if (index === undefined) {
        return 0
      }
      return this.ttls[index] === 0 || this.starts[index] === 0
        ? Infinity
        : this.starts[index] +
            this.ttls[index] -
            (cachedNow || getNow())
    }

    this.isStale = index => {
      return (
        this.ttls[index] !== 0 &&
        this.starts[index] !== 0 &&
        (cachedNow || getNow()) - this.starts[index] >
          this.ttls[index]
      )
    }
  }
  updateItemAge(_index) {}
  statusTTL(_status, _index) {}
  setItemTTL(_index, _ttl, _start) {}
  isStale(_index) {
    return false
  }

  initializeSizeTracking() {
    this.calculatedSize = 0
    this.sizes = new ZeroArray(this.max)
    this.removeItemSize = index => {
      this.calculatedSize -= this.sizes[index]
      this.sizes[index] = 0
    }
    this.requireSize = (k, v, size, sizeCalculation) => {
      // provisionally accept background fetches.
      // actual value size will be checked when they return.
      if (this.isBackgroundFetch(v)) {
        return 0
      }
      if (!isPosInt(size)) {
        if (sizeCalculation) {
          if (typeof sizeCalculation !== 'function') {
            throw new TypeError('sizeCalculation must be a function')
          }
          size = sizeCalculation(v, k)
          if (!isPosInt(size)) {
            throw new TypeError(
              'sizeCalculation return invalid (expect positive integer)'
            )
          }
        } else {
          throw new TypeError(
            'invalid size value (must be positive integer). ' +
              'When maxSize or maxEntrySize is used, sizeCalculation or size ' +
              'must be set.'
          )
        }
      }
      return size
    }
    this.addItemSize = (index, size, status) => {
      this.sizes[index] = size
      if (this.maxSize) {
        const maxSize = this.maxSize - this.sizes[index]
        while (this.calculatedSize > maxSize) {
          this.evict(true)
        }
      }
      this.calculatedSize += this.sizes[index]
      if (status) {
        status.entrySize = size
        status.totalCalculatedSize = this.calculatedSize
      }
    }
  }
  removeItemSize(_index) {}
  addItemSize(_index, _size) {}
  requireSize(_k, _v, size, sizeCalculation) {
    if (size || sizeCalculation) {
      throw new TypeError(
        'cannot set size without setting maxSize or maxEntrySize on cache'
      )
    }
  }

  *indexes({ allowStale = this.allowStale } = {}) {
    if (this.size) {
      for (let i = this.tail; true; ) {
        if (!this.isValidIndex(i)) {
          break
        }
        if (allowStale || !this.isStale(i)) {
          yield i
        }
        if (i === this.head) {
          break
        } else {
          i = this.prev[i]
        }
      }
    }
  }

  *rindexes({ allowStale = this.allowStale } = {}) {
    if (this.size) {
      for (let i = this.head; true; ) {
        if (!this.isValidIndex(i)) {
          break
        }
        if (allowStale || !this.isStale(i)) {
          yield i
        }
        if (i === this.tail) {
          break
        } else {
          i = this.next[i]
        }
      }
    }
  }

  isValidIndex(index) {
    return (
      index !== undefined &&
      this.keyMap.get(this.keyList[index]) === index
    )
  }

  *entries() {
    for (const i of this.indexes()) {
      if (
        this.valList[i] !== undefined &&
        this.keyList[i] !== undefined &&
        !this.isBackgroundFetch(this.valList[i])
      ) {
        yield [this.keyList[i], this.valList[i]]
      }
    }
  }
  *rentries() {
    for (const i of this.rindexes()) {
      if (
        this.valList[i] !== undefined &&
        this.keyList[i] !== undefined &&
        !this.isBackgroundFetch(this.valList[i])
      ) {
        yield [this.keyList[i], this.valList[i]]
      }
    }
  }

  *keys() {
    for (const i of this.indexes()) {
      if (
        this.keyList[i] !== undefined &&
        !this.isBackgroundFetch(this.valList[i])
      ) {
        yield this.keyList[i]
      }
    }
  }
  *rkeys() {
    for (const i of this.rindexes()) {
      if (
        this.keyList[i] !== undefined &&
        !this.isBackgroundFetch(this.valList[i])
      ) {
        yield this.keyList[i]
      }
    }
  }

  *values() {
    for (const i of this.indexes()) {
      if (
        this.valList[i] !== undefined &&
        !this.isBackgroundFetch(this.valList[i])
      ) {
        yield this.valList[i]
      }
    }
  }
  *rvalues() {
    for (const i of this.rindexes()) {
      if (
        this.valList[i] !== undefined &&
        !this.isBackgroundFetch(this.valList[i])
      ) {
        yield this.valList[i]
      }
    }
  }

  [Symbol.iterator]() {
    return this.entries()
  }

  find(fn, getOptions) {
    for (const i of this.indexes()) {
      const v = this.valList[i]
      const value = this.isBackgroundFetch(v)
        ? v.__staleWhileFetching
        : v
      if (value === undefined) continue
      if (fn(value, this.keyList[i], this)) {
        return this.get(this.keyList[i], getOptions)
      }
    }
  }

  forEach(fn, thisp = this) {
    for (const i of this.indexes()) {
      const v = this.valList[i]
      const value = this.isBackgroundFetch(v)
        ? v.__staleWhileFetching
        : v
      if (value === undefined) continue
      fn.call(thisp, value, this.keyList[i], this)
    }
  }

  rforEach(fn, thisp = this) {
    for (const i of this.rindexes()) {
      const v = this.valList[i]
      const value = this.isBackgroundFetch(v)
        ? v.__staleWhileFetching
        : v
      if (value === undefined) continue
      fn.call(thisp, value, this.keyList[i], this)
    }
  }

  get prune() {
    deprecatedMethod('prune', 'purgeStale')
    return this.purgeStale
  }

  purgeStale() {
    let deleted = false
    for (const i of this.rindexes({ allowStale: true })) {
      if (this.isStale(i)) {
        this.delete(this.keyList[i])
        deleted = true
      }
    }
    return deleted
  }

  dump() {
    const arr = []
    for (const i of this.indexes({ allowStale: true })) {
      const key = this.keyList[i]
      const v = this.valList[i]
      const value = this.isBackgroundFetch(v)
        ? v.__staleWhileFetching
        : v
      if (value === undefined) continue
      const entry = { value }
      if (this.ttls) {
        entry.ttl = this.ttls[i]
        // always dump the start relative to a portable timestamp
        // it's ok for this to be a bit slow, it's a rare operation.
        const age = perf.now() - this.starts[i]
        entry.start = Math.floor(Date.now() - age)
      }
      if (this.sizes) {
        entry.size = this.sizes[i]
      }
      arr.unshift([key, entry])
    }
    return arr
  }

  load(arr) {
    this.clear()
    for (const [key, entry] of arr) {
      if (entry.start) {
        // entry.start is a portable timestamp, but we may be using
        // node's performance.now(), so calculate the offset.
        // it's ok for this to be a bit slow, it's a rare operation.
        const age = Date.now() - entry.start
        entry.start = perf.now() - age
      }
      this.set(key, entry.value, entry)
    }
  }

  dispose(_v, _k, _reason) {}

  set(
    k,
    v,
    {
      ttl = this.ttl,
      start,
      noDisposeOnSet = this.noDisposeOnSet,
      size = 0,
      sizeCalculation = this.sizeCalculation,
      noUpdateTTL = this.noUpdateTTL,
      status,
    } = {}
  ) {
    size = this.requireSize(k, v, size, sizeCalculation)
    // if the item doesn't fit, don't do anything
    // NB: maxEntrySize set to maxSize by default
    if (this.maxEntrySize && size > this.maxEntrySize) {
      if (status) {
        status.set = 'miss'
        status.maxEntrySizeExceeded = true
      }
      // have to delete, in case a background fetch is there already.
      // in non-async cases, this is a no-op
      this.delete(k)
      return this
    }
    let index = this.size === 0 ? undefined : this.keyMap.get(k)
    if (index === undefined) {
      // addition
      index = this.newIndex()
      this.keyList[index] = k
      this.valList[index] = v
      this.keyMap.set(k, index)
      this.next[this.tail] = index
      this.prev[index] = this.tail
      this.tail = index
      this.size++
      this.addItemSize(index, size, status)
      if (status) {
        status.set = 'add'
      }
      noUpdateTTL = false
    } else {
      // update
      this.moveToTail(index)
      const oldVal = this.valList[index]
      if (v !== oldVal) {
        if (this.isBackgroundFetch(oldVal)) {
          oldVal.__abortController.abort(new Error('replaced'))
        } else {
          if (!noDisposeOnSet) {
            this.dispose(oldVal, k, 'set')
            if (this.disposeAfter) {
              this.disposed.push([oldVal, k, 'set'])
            }
          }
        }
        this.removeItemSize(index)
        this.valList[index] = v
        this.addItemSize(index, size, status)
        if (status) {
          status.set = 'replace'
          const oldValue =
            oldVal && this.isBackgroundFetch(oldVal)
              ? oldVal.__staleWhileFetching
              : oldVal
          if (oldValue !== undefined) status.oldValue = oldValue
        }
      } else if (status) {
        status.set = 'update'
      }
    }
    if (ttl !== 0 && this.ttl === 0 && !this.ttls) {
      this.initializeTTLTracking()
    }
    if (!noUpdateTTL) {
      this.setItemTTL(index, ttl, start)
    }
    this.statusTTL(status, index)
    if (this.disposeAfter) {
      while (this.disposed.length) {
        this.disposeAfter(...this.disposed.shift())
      }
    }
    return this
  }

  newIndex() {
    if (this.size === 0) {
      return this.tail
    }
    if (this.size === this.max && this.max !== 0) {
      return this.evict(false)
    }
    if (this.free.length !== 0) {
      return this.free.pop()
    }
    // initial fill, just keep writing down the list
    return this.initialFill++
  }

  pop() {
    if (this.size) {
      const val = this.valList[this.head]
      this.evict(true)
      return val
    }
  }

  evict(free) {
    const head = this.head
    const k = this.keyList[head]
    const v = this.valList[head]
    if (this.isBackgroundFetch(v)) {
      v.__abortController.abort(new Error('evicted'))
    } else {
      this.dispose(v, k, 'evict')
      if (this.disposeAfter) {
        this.disposed.push([v, k, 'evict'])
      }
    }
    this.removeItemSize(head)
    // if we aren't about to use the index, then null these out
    if (free) {
      this.keyList[head] = null
      this.valList[head] = null
      this.free.push(head)
    }
    this.head = this.next[head]
    this.keyMap.delete(k)
    this.size--
    return head
  }

  has(k, { updateAgeOnHas = this.updateAgeOnHas, status } = {}) {
    const index = this.keyMap.get(k)
    if (index !== undefined) {
      if (!this.isStale(index)) {
        if (updateAgeOnHas) {
          this.updateItemAge(index)
        }
        if (status) status.has = 'hit'
        this.statusTTL(status, index)
        return true
      } else if (status) {
        status.has = 'stale'
        this.statusTTL(status, index)
      }
    } else if (status) {
      status.has = 'miss'
    }
    return false
  }

  // like get(), but without any LRU updating or TTL expiration
  peek(k, { allowStale = this.allowStale } = {}) {
    const index = this.keyMap.get(k)
    if (index !== undefined && (allowStale || !this.isStale(index))) {
      const v = this.valList[index]
      // either stale and allowed, or forcing a refresh of non-stale value
      return this.isBackgroundFetch(v) ? v.__staleWhileFetching : v
    }
  }

  backgroundFetch(k, index, options, context) {
    const v = index === undefined ? undefined : this.valList[index]
    if (this.isBackgroundFetch(v)) {
      return v
    }
    const ac = new AC()
    if (options.signal) {
      options.signal.addEventListener('abort', () =>
        ac.abort(options.signal.reason)
      )
    }
    const fetchOpts = {
      signal: ac.signal,
      options,
      context,
    }
    const cb = (v, updateCache = false) => {
      const { aborted } = ac.signal
      const ignoreAbort = options.ignoreFetchAbort && v !== undefined
      if (options.status) {
        if (aborted && !updateCache) {
          options.status.fetchAborted = true
          options.status.fetchError = ac.signal.reason
          if (ignoreAbort) options.status.fetchAbortIgnored = true
        } else {
          options.status.fetchResolved = true
        }
      }
      if (aborted && !ignoreAbort && !updateCache) {
        return fetchFail(ac.signal.reason)
      }
      // either we didn't abort, and are still here, or we did, and ignored
      if (this.valList[index] === p) {
        if (v === undefined) {
          if (p.__staleWhileFetching) {
            this.valList[index] = p.__staleWhileFetching
          } else {
            this.delete(k)
          }
        } else {
          if (options.status) options.status.fetchUpdated = true
          this.set(k, v, fetchOpts.options)
        }
      }
      return v
    }
    const eb = er => {
      if (options.status) {
        options.status.fetchRejected = true
        options.status.fetchError = er
      }
      return fetchFail(er)
    }
    const fetchFail = er => {
      const { aborted } = ac.signal
      const allowStaleAborted =
        aborted && options.allowStaleOnFetchAbort
      const allowStale =
        allowStaleAborted || options.allowStaleOnFetchRejection
      const noDelete = allowStale || options.noDeleteOnFetchRejection
      if (this.valList[index] === p) {
        // if we allow stale on fetch rejections, then we need to ensure that
        // the stale value is not removed from the cache when the fetch fails.
        const del = !noDelete || p.__staleWhileFetching === undefined
        if (del) {
          this.delete(k)
        } else if (!allowStaleAborted) {
          // still replace the *promise* with the stale value,
          // since we are done with the promise at this point.
          // leave it untouched if we're still waiting for an
          // aborted background fetch that hasn't yet returned.
          this.valList[index] = p.__staleWhileFetching
        }
      }
      if (allowStale) {
        if (options.status && p.__staleWhileFetching !== undefined) {
          options.status.returnedStale = true
        }
        return p.__staleWhileFetching
      } else if (p.__returned === p) {
        throw er
      }
    }
    const pcall = (res, rej) => {
      this.fetchMethod(k, v, fetchOpts).then(v => res(v), rej)
      // ignored, we go until we finish, regardless.
      // defer check until we are actually aborting,
      // so fetchMethod can override.
      ac.signal.addEventListener('abort', () => {
        if (
          !options.ignoreFetchAbort ||
          options.allowStaleOnFetchAbort
        ) {
          res()
          // when it eventually resolves, update the cache.
          if (options.allowStaleOnFetchAbort) {
            res = v => cb(v, true)
          }
        }
      })
    }
    if (options.status) options.status.fetchDispatched = true
    const p = new Promise(pcall).then(cb, eb)
    p.__abortController = ac
    p.__staleWhileFetching = v
    p.__returned = null
    if (index === undefined) {
      // internal, don't expose status.
      this.set(k, p, { ...fetchOpts.options, status: undefined })
      index = this.keyMap.get(k)
    } else {
      this.valList[index] = p
    }
    return p
  }

  isBackgroundFetch(p) {
    return (
      p &&
      typeof p === 'object' &&
      typeof p.then === 'function' &&
      Object.prototype.hasOwnProperty.call(
        p,
        '__staleWhileFetching'
      ) &&
      Object.prototype.hasOwnProperty.call(p, '__returned') &&
      (p.__returned === p || p.__returned === null)
    )
  }

  // this takes the union of get() and set() opts, because it does both
  async fetch(
    k,
    {
      // get options
      allowStale = this.allowStale,
      updateAgeOnGet = this.updateAgeOnGet,
      noDeleteOnStaleGet = this.noDeleteOnStaleGet,
      // set options
      ttl = this.ttl,
      noDisposeOnSet = this.noDisposeOnSet,
      size = 0,
      sizeCalculation = this.sizeCalculation,
      noUpdateTTL = this.noUpdateTTL,
      // fetch exclusive options
      noDeleteOnFetchRejection = this.noDeleteOnFetchRejection,
      allowStaleOnFetchRejection = this.allowStaleOnFetchRejection,
      ignoreFetchAbort = this.ignoreFetchAbort,
      allowStaleOnFetchAbort = this.allowStaleOnFetchAbort,
      fetchContext = this.fetchContext,
      forceRefresh = false,
      status,
      signal,
    } = {}
  ) {
    if (!this.fetchMethod) {
      if (status) status.fetch = 'get'
      return this.get(k, {
        allowStale,
        updateAgeOnGet,
        noDeleteOnStaleGet,
        status,
      })
    }

    const options = {
      allowStale,
      updateAgeOnGet,
      noDeleteOnStaleGet,
      ttl,
      noDisposeOnSet,
      size,
      sizeCalculation,
      noUpdateTTL,
      noDeleteOnFetchRejection,
      allowStaleOnFetchRejection,
      allowStaleOnFetchAbort,
      ignoreFetchAbort,
      status,
      signal,
    }

    let index = this.keyMap.get(k)
    if (index === undefined) {
      if (status) status.fetch = 'miss'
      const p = this.backgroundFetch(k, index, options, fetchContext)
      return (p.__returned = p)
    } else {
      // in cache, maybe already fetching
      const v = this.valList[index]
      if (this.isBackgroundFetch(v)) {
        const stale =
          allowStale && v.__staleWhileFetching !== undefined
        if (status) {
          status.fetch = 'inflight'
          if (stale) status.returnedStale = true
        }
        return stale ? v.__staleWhileFetching : (v.__returned = v)
      }

      // if we force a refresh, that means do NOT serve the cached value,
      // unless we are already in the process of refreshing the cache.
      const isStale = this.isStale(index)
      if (!forceRefresh && !isStale) {
        if (status) status.fetch = 'hit'
        this.moveToTail(index)
        if (updateAgeOnGet) {
          this.updateItemAge(index)
        }
        this.statusTTL(status, index)
        return v
      }

      // ok, it is stale or a forced refresh, and not already fetching.
      // refresh the cache.
      const p = this.backgroundFetch(k, index, options, fetchContext)
      const hasStale = p.__staleWhileFetching !== undefined
      const staleVal = hasStale && allowStale
      if (status) {
        status.fetch = hasStale && isStale ? 'stale' : 'refresh'
        if (staleVal && isStale) status.returnedStale = true
      }
      return staleVal ? p.__staleWhileFetching : (p.__returned = p)
    }
  }

  get(
    k,
    {
      allowStale = this.allowStale,
      updateAgeOnGet = this.updateAgeOnGet,
      noDeleteOnStaleGet = this.noDeleteOnStaleGet,
      status,
    } = {}
  ) {
    const index = this.keyMap.get(k)
    if (index !== undefined) {
      const value = this.valList[index]
      const fetching = this.isBackgroundFetch(value)
      this.statusTTL(status, index)
      if (this.isStale(index)) {
        if (status) status.get = 'stale'
        // delete only if not an in-flight background fetch
        if (!fetching) {
          if (!noDeleteOnStaleGet) {
            this.delete(k)
          }
          if (status) status.returnedStale = allowStale
          return allowStale ? value : undefined
        } else {
          if (status) {
            status.returnedStale =
              allowStale && value.__staleWhileFetching !== undefined
          }
          return allowStale ? value.__staleWhileFetching : undefined
        }
      } else {
        if (status) status.get = 'hit'
        // if we're currently fetching it, we don't actually have it yet
        // it's not stale, which means this isn't a staleWhileRefetching.
        // If it's not stale, and fetching, AND has a __staleWhileFetching
        // value, then that means the user fetched with {forceRefresh:true},
        // so it's safe to return that value.
        if (fetching) {
          return value.__staleWhileFetching
        }
        this.moveToTail(index)
        if (updateAgeOnGet) {
          this.updateItemAge(index)
        }
        return value
      }
    } else if (status) {
      status.get = 'miss'
    }
  }

  connect(p, n) {
    this.prev[n] = p
    this.next[p] = n
  }

  moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== this.tail) {
      if (index === this.head) {
        this.head = this.next[index]
      } else {
        this.connect(this.prev[index], this.next[index])
      }
      this.connect(this.tail, index)
      this.tail = index
    }
  }

  get del() {
    deprecatedMethod('del', 'delete')
    return this.delete
  }

  delete(k) {
    let deleted = false
    if (this.size !== 0) {
      const index = this.keyMap.get(k)
      if (index !== undefined) {
        deleted = true
        if (this.size === 1) {
          this.clear()
        } else {
          this.removeItemSize(index)
          const v = this.valList[index]
          if (this.isBackgroundFetch(v)) {
            v.__abortController.abort(new Error('deleted'))
          } else {
            this.dispose(v, k, 'delete')
            if (this.disposeAfter) {
              this.disposed.push([v, k, 'delete'])
            }
          }
          this.keyMap.delete(k)
          this.keyList[index] = null
          this.valList[index] = null
          if (index === this.tail) {
            this.tail = this.prev[index]
          } else if (index === this.head) {
            this.head = this.next[index]
          } else {
            this.next[this.prev[index]] = this.next[index]
            this.prev[this.next[index]] = this.prev[index]
          }
          this.size--
          this.free.push(index)
        }
      }
    }
    if (this.disposed) {
      while (this.disposed.length) {
        this.disposeAfter(...this.disposed.shift())
      }
    }
    return deleted
  }

  clear() {
    for (const index of this.rindexes({ allowStale: true })) {
      const v = this.valList[index]
      if (this.isBackgroundFetch(v)) {
        v.__abortController.abort(new Error('deleted'))
      } else {
        const k = this.keyList[index]
        this.dispose(v, k, 'delete')
        if (this.disposeAfter) {
          this.disposed.push([v, k, 'delete'])
        }
      }
    }

    this.keyMap.clear()
    this.valList.fill(null)
    this.keyList.fill(null)
    if (this.ttls) {
      this.ttls.fill(0)
      this.starts.fill(0)
    }
    if (this.sizes) {
      this.sizes.fill(0)
    }
    this.head = 0
    this.tail = 0
    this.initialFill = 1
    this.free.length = 0
    this.calculatedSize = 0
    this.size = 0
    if (this.disposed) {
      while (this.disposed.length) {
        this.disposeAfter(...this.disposed.shift())
      }
    }
  }

  get reset() {
    deprecatedMethod('reset', 'clear')
    return this.clear
  }

  get length() {
    deprecatedProperty('length', 'size')
    return this.size
  }

  static get AbortController() {
    return AC
  }
  static get AbortSignal() {
    return AS
  }
}

module.exports = LRUCache


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!*******************************!*\
  !*** ./scripts/ip-tracker.js ***!
  \*******************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var node_ipinfo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! node-ipinfo */ "./node_modules/node-ipinfo/dist/src/index.js");
/* harmony import */ var node_ipinfo__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(node_ipinfo__WEBPACK_IMPORTED_MODULE_0__);

var currentIp = new node_ipinfo__WEBPACK_IMPORTED_MODULE_0__.IPinfoWrapper(JSON);
fetch("".concat(currentIp.baseUrl, "/json")).then(function (ip) {
  return ip.json();
}).then(function (detail) {
  var updatedDetails = {
    city: detail.city,
    country: detail.country,
    region: detail.region,
    ip: detail.ip
  };
  var ipinfo = localStorage.getItem('ipinfo');
  if (ipinfo === null) {
    localStorage.setItem('ipinfo', JSON.stringify(updatedDetails));
  } else if (ipinfo != null && JSON.parse(ipinfo).ip != detail.ip) {
    localStorage.setItem('ipinfo', JSON.stringify(updatedDetails));
  }
});
})();

/******/ })()
;